import React from 'react';
import '../template-file-css/document-file-template.css';


export const JCS_BhaAdult = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='JCS_BhaAdult' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'> <center> <h2> Jenkins Counseling Services </h2> </center>
                </p>

                <p className='w-750'> <center> <h4> Behavioral Health Assessment </h4> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Preferred Name </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Parent/Guardian Name </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Relationship: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtPreferredName' name='txtPreferredName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtGuardianName' name='txtGuardianName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRelationship' name='txtRelationship' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> MCO: </span> </td>
                        <td className='w-250'> <span className='eleHeader'> MCD Number </span> </td>
                        <td className='w-250'> <span className='eleHeader'> SSN </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtMco' name='txtMco' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtMcdNumber' name='txtMcdNumber' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtSsn' name='txtSsn' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Gender </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Gender Expression </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Marital Status </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtGender' name='txtGender' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtGenderExpression' name='txtGenderExpression' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtMaritalStatus' name='txtMaritalStatus' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'> Emergency Contact Name </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Relationship to Client </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Phone Number </span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtEmergencyContactName' name='txtEmergencyContactName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtRelationshipToClient' name='txtRelationshipToClient' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPhoneNumber_1' name='txtPhoneNumber_1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Diagnosis Code </span> </td>
                        <td className='w-375'> <span className='eleHeader'> LOCUS/CALOCUS Score </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtDiagnosisCode' name='txtDiagnosisCode' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtCalocusScore' name='txtCalocusScore' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'> Chief Complaint/ Presenting Problem </span>
                    <span className='small'> (Reason client is seeking services, include symptoms) In the client's words. </span>
                    <textarea id='txtChiefComplaint' name='txtChiefComplaint' className='add-only'> </textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'> Current Behavioral Health Provider Name </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Phone Number </span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtBehavioralHealth' name='txtBehavioralHealth' className='add-only' defaultValue='Jenkins Counseling Services' /> </td>
                        <td className='w-250'> <input type='text' id='txtPhoneNumber_2' name='txtPhoneNumber_2' className='add-only' defaultValue='318—754-3890' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'> Who referred you? </span>
                </p>
                <p className='w-750'> <input type='text' id='txtReferredYou' name='txtReferredYou' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Living Situation </span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbLivingSituationOwnsHome' name='rbLivingSituation' className='add-only' value='Owns Home' /> Owns Home </td>
                        <td className='w-250'>
                            <input type='radio' id='rbLivingSituationApartment' name='rbLivingSituation' className='add-only' value='Apartment' /> Apartment </td>
                        <td className='w-250'>
                            <input type='radio' id='rbLivingSituationRoomingHouse' name='rbLivingSituation' className='add-only' value='Rooming House' /> Rooming House
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbLivingSituationGroupResidence' name='rbLivingSituation' className='add-only' value='Group Residence' /> Group Residence </td>
                        <td className='w-250'>
                            <input type='radio' id='rbLivingSituationFosterCare' name='rbLivingSituation' className='add-only' value='Foster Care' /> Foster Care </td>
                    </tr>
                    <tr>
                        <td className='w-750'> Other: <input type='text' id='txtOther_150' name='txtOther_150' className='add-only w-350 custom-add-only' /></td>
                    </tr>
                </table>
                <p className='w-750'> <span className='eleHeader'> Household members and ages </span>
                </p>
                <p className='w-750'> <input type='text' id='txtHouseholdMembers' name='txtHouseholdMembers' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> How long at current residence? </span>
                </p>
                <p className='w-750'> <input type='text' id='txtCurrentResidence' name='txtCurrentResidence' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> How long have you lived in this community? </span>
                </p>
                <p className='w-750'> <input type='text' id='txtCommunity' name='txtCommunity' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Source of Meals/Food: </span>
                </p>
                <p className='w-750'> <input type='text' id='txtSourceOfMeals' name='txtSourceOfMeals' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Means of Transportation: </span>
                </p>
                <p className='w-750'> <input type='text' id='txtMeansOfTransportation' name='txtMeansOfTransportation' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Family Involvement: </span>
                </p>
                <p className='w-750'> <input type='text' id='txtFamilyInvolvement' name='txtFamilyInvolvement' className='add-only' />
                </p>
                <p className='w-750'> <center> <h5> <b> Race, Culture, Ethnicity, Religion </b> </h5> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Language spoken at home </span> </td>

                    </tr>

                    <tr>
                        <td className='w-750'> <input type='text' id='txtLanguageSpoken' name='txtLanguageSpoken' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Race </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Culture </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtRace' name='txtRace' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtCulture' name='txtCulture' className='add-only' /> </td>
                    </tr>


                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Ethnicity </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Religion/Faith/Spirituality raised in, if any </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtEthnicity' name='txtEthnicity' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtFaith' name='txtFaith' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> Religion/Faith/Spirituality currently practiced if any </span> </td>

                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtSpirituality' name='txtSpirituality' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'> <center> <h5> <b> Education/Employment/Rehabilitation </b> </h5> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Current Source of Income </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Estimated Monthly Income Amount </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtCurrentSource' name='txtCurrentSource' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMonthlyIncome' name='txtMonthlyIncome' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Military Status </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Military Trauma </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMilitaryStatus' name='txtMilitaryStatus' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtMilitaryTrauma' name='txtMilitaryTrauma' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Highest Grade or Completed Degree </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Difficulties with Reading/Writing </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtHighestGrade' name='txtHighestGrade' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtDifficulties' name='txtDifficulties' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Estimated Literacy Level </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Current Employment Status </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtEstimatedLiteracy' name='txtEstimatedLiteracy' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtCurrentEmployment' name='txtCurrentEmployment' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Prior Employment Status </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Assistive Devices utilized/required </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtPriorEmployment' name='txtPriorEmployment' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtAssistiveDevices' name='txtAssistiveDevices' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'> <center> <h5> <b> Legal Status </b> </h5> </center>
                </p>

                <p className='w-750'> <span className='eleHeader'> Current Legal Status </span>
                </p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbCurrentNone' name='rbCurrentLegalStatus' className='add-only' value='None' /> None </td>
                        <td className='w-300'>
                            <input type='radio' id='rbParole' name='rbCurrentLegalStatus' className='add-only' value='Parole' /> Parole </td>
                        <td className='w-200'>
                            <input type='radio' id='rbProbation' name='rbCurrentLegalStatus' className='add-only' value='Probation' /> Probation
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <input type='radio' id='rbChargesPending' name='rbCurrentLegalStatus' className='add-only' value='ChargesPending' /> Charges Pending
                        </td>
                        <td className='w-300'> <input type='radio' id='rbCourtOrdered' name='rbCurrentLegalStatus' className='add-only' value='CourtOrdered' /> Court Ordered Outpatient Treatment
                        </td>
                        <td className='w-200'> <input type='radio' id='rbAot' name='rbCurrentLegalStatus' className='add-only' value='Aot' /> AOT
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='radio' id='rbJudicial' name='rbCurrentLegalStatus' className='add-only' value='Judicial' /> Judicial
                        </td>
                    </tr>
                </table>
                <p className='w-750'> <b> Comment/Detail: </b>
                </p>

                <p className='w-750'> <input type='text' id='txtCurrentLegalStatusComment' name='txtCurrentLegalStatusComment' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Past Legal Status </span>
                </p>

                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbPastNone' name='rbPastLegalStatus' className='add-only' value='None' /> None </td>
                        <td className='w-187'>
                            <input type='radio' id='rbDwi' name='rbPastLegalStatus' className='add-only' value='Dwi' /> DWI </td>
                        <td className='w-187'>
                            <input type='radio' id='rbPriorArrests' name='rbPastLegalStatus' className='add-only' value='PriorArrests' /> Prior Arrests
                        </td>
                        <td className='w-187'> <input type='radio' id='rbIncarcerations' name='rbPastLegalStatus' className='add-only' value='Incarcerations' /> Incarcerations
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <b> Comment/Detail: </b>
                </p>

                <p className='w-750'> <input type='text' id='txtPastLegalStatus' name='txtPastLegalStatus' className='add-only' />
                </p>

                <p className='w-750'> <center> <h5> <b> Social History and Community Integration </b> </h5> </center>
                </p>

                <p className='w-750'> <span className='eleHeader'> Does client feel supported by family or friends? </span>
                </p>

                <p className='w-750'>
                    <input type='radio' id='rbFeelSupportedYes' name='rbFeelSupported' className='add-only' value='FeelSupportedYes' /> Yes &nbsp;
                    <input type='radio' id='rbFeelSupportedNo' name='rbFeelSupported' className='add-only' value='FeelSupportedNo' /> No
                </p>

                <p className='w-750'> <span className='eleHeader'> Recreational Activities </span>
                </p>

                <p className='w-750'>
                    <input type='text' id='txtRecreationalActivities' name='txtRecreationalActivities' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Self-Help Activities </span>
                </p>

                <p className='w-750'>
                    <input type='text' id='txtSelfHelpActivities' name='txtSelfHelpActivities' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Social Clubs/Organizations </span> </p>

                <p className='w-750'>
                    <input type='text' id='txtSocialClubsOrganizations' name='txtSocialClubsOrganizations' className='add-only' />
                </p>

                <p className='w-750'> <center> <h5> <b> Other Agencies or Providers Involved </b> </h5> </center>
                </p>

                <p className='w-750'> <span className='eleHeader'> Previous Outpatient Mental Health Treatment: </span>
                </p>

                <p className='w-750'> <input type='text' id='txtMentalHealth' name='txtMentalHealth' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'> Previous Psychiatric Hospitalizations </span>
                </p>
                <p className='w-750'> <input type='text' id='txtPreviousPsychiatric' name='txtPreviousPsychiatric' className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'> Primary Care Provider </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Phone Number </span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtCareProvider' name='txtCareProvider' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPhoneNumber_3' name='txtPhoneNumber_3' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <center> <h5> <b> Medical History </b> </h5> </center>
                </p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant' name='cbPregnant' className='add-only' value='Pregnant' /> Pregnant </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDueDate' name='cbDueDate' className='add-only' value='DueDate' /> Due Date </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPrenatalCare' name='cbPrenatalCare' className='add-only' value='PrenatalCare' /> Prenatal Care
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBreastfeeding' name='cbBreastfeeding' className='add-only' value='Breastfeeding' /> Breastfeeding
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNoneReported_1' name='cbNoneReported_1' className='add-only' value='NoneReported' /> None Reported </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHeartFailure' name='cbHeartFailure' className='add-only' value='CongestiveHeartFailure' /> Congestive Heart Failure </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAsthma' name='cbAsthma' className='add-only' value='Asthma' /> Asthma
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSeizure' name='cbSeizure' className='add-only' value='Seizure' /> Seizure
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCancer' name='cbCancer' className='add-only' value='Cancer' /> Cancer </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbUnderweight' name='cbUnderweight' className='add-only' value='Underweight' /> Underweight </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHighBlood' name='cbHighBlood' className='add-only' value='HighBloodPressure' /> High Blood Pressure
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbStoke' name='cbStoke' className='add-only' value='Stoke' /> Stoke
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEmphysema' name='cbEmphysema' className='add-only' value='Emphysema' /> Emphysema </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCirrhosis' name='cbCirrhosis' className='add-only' value='Cirrhosis' /> Cirrhosis </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbChronicPain' name='cbChronicPain' className='add-only' value='ChronicPain' /> Chronic Pain
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOverweight' name='cbOverweight' className='add-only' value='Overweight' /> Overweight
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHeartDisease' name='cbHeartDisease' className='add-only' value='HeartDisease' /> Heart Disease </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDiabetes' name='cbDiabetes' className='add-only' value='Diabetes' /> Diabetes </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEpilepsy' name='cbEpilepsy' className='add-only' value='Epilepsy' /> Epilepsy
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDigestiveProblems' name='cbDigestiveProblems' className='add-only' value='DigestiveProblems' /> Digestive Problems
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThyroidDisease' name='cbThyroidDisease' className='add-only' value='ThyroidDisease' /> Thyroid Disease </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSexuallyTransmitted' name='cbSexuallyTransmitted' className='add-only' value='SexuallyTransmittedDisease' /> Sexually Transmitted Disease </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHighCholesterol' name='cbHighCholesterol' className='add-only' value='HighCholesterol' /> High Cholesterol
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHiv' name='cbHiv' className='add-only' value='Hiv' /> HIV
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbArthritis' name='cbArthritis' className='add-only' value='Arthritis' /> Arthritis </td>

                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbOther' name='cbOther' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtMedicalHistoryOther' name='txtMedicalHistoryOther' className='add-only w-250 custom-add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>(1) Types of Illness, Surgery</span></td>
                        <td className='w-250'><span className='eleHeader'>Date or Age of Onset</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type='text' name='txtIlleness_1' id='txtIlleness_1' className='add-only' /></td>
                        <td className='w-250'><input type='text' name='txtIllenessDate_1' id='txtIllenessDate_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Medications </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Relevant Information </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedications_1' name='txtMedications_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRelevantInformation_1' name='txtRelevantInformation_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>(2) Types of Illness, Surgery</span></td>
                        <td className='w-250'><span className='eleHeader'>Date or Age of Onset</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type='text' name='txtIlleness_2' id='txtIlleness_2' className='add-only' /></td>
                        <td className='w-250'><input type='text' name='txtIllenessDate_2' id='txtIllenessDate_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Medications </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Relevant Information </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedications_2' name='txtMedications_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRelevantInformation_2' name='txtRelevantInformation_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>(3(1) ) Types of Illness, Surgery</span></td>
                        <td className='w-250'><span className='eleHeader'>Date or Age of Onset</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type='text' name='txtIlleness_3' id='txtIlleness_3' className='add-only' /></td>
                        <td className='w-250'><input type='text' name='txtIllenessDate_3' id='txtIllenessDate_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Medications </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Relevant Information </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedications_3' name='txtMedications_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRelevantInformation_3' name='txtRelevantInformation_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>(4) Types of Illness, Surgery</span></td>
                        <td className='w-250'><span className='eleHeader'>Date or Age of Onset</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type='text' name='txtIlleness_4' id='txtIlleness_4' className='add-only' /></td>
                        <td className='w-250'><input type='text' name='txtIllenessDate_4' id='txtIllenessDate_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Medications </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Relevant Information </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedications_4' name='txtMedications_4' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRelevantInformation_4' name='txtRelevantInformation_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>(5) Types of Illness, Surgery</span></td>
                        <td className='w-250'><span className='eleHeader'>Date or Age of Onset</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type='text' name='txtIlleness_5' id='txtIlleness_5' className='add-only' /></td>
                        <td className='w-250'><input type='text' name='txtIllenessDate_5' id='txtIllenessDate_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'> Medications </span> </td>
                        <td className='w-375'> <span className='eleHeader'> Relevant Information </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtMedications_5' name='txtMedications_5' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRelevantInformation_5' name='txtRelevantInformation_5' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'> <span className='eleHeader'> Allergies </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbFoodAllergies' name='cbFoodAllergies' className='add-only' value='NoReportedDrug' /> No Reported Drug or Food Allergies <br />
                    <input type='checkbox' id='cbAllergiesOther' name='cbAllergiesOther' className='add-only' value='Other' /> Other:
                </p>

                <p className='w-750'>
                    <input type='text' id='txtRelevantInformation_5' name='txtRelevantInformation_5' className='add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'> Additional Medical Information: </span>
                    <textarea id='txtMedicalInformation' name='txtMedicalInformation' className='add-only'> </textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'> Medications </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbNoneReported_2' name='cbNoneReported_2' className='add-only' value='NoReportedDrug' /> None Reported
                </p>
                <table>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'> Medication Name </span> </td>
                        <td className='w-100'> <span className='eleHeader'> Dosage </span> </td>
                        <td className='w-100'> <span className='eleHeader'> Frequency </span> </td>
                        <td className='w-125'> <span className='eleHeader'> Current/Past </span> </td>
                        <td className='w-150'> <span className='eleHeader'> Reason Prescribed </span> </td>
                        <td className='w-125'> <span className='eleHeader'> Response </span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='MedicationName_1' name='MedicationName_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Dosage_1' name='Dosage_1' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Frequency_1' name='Frequency_1' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='CurrentPast_1' name='CurrentPast_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='ReasonPrescribed_1' name='ReasonPrescribed_1' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='Response_1' name='Response_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='MedicationName_2' name='MedicationName_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Dosage_2' name='Dosage_2' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Frequency_2' name='Frequency_2' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='CurrentPast_2' name='CurrentPast_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='ReasonPrescribed_2' name='ReasonPrescribed_2' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='Response_2' name='Response_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='MedicationName_3' name='MedicationName_3' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Dosage_3' name='Dosage_3' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Frequency_3' name='Frequency_3' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='CurrentPast_3' name='CurrentPast_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='ReasonPrescribed_3' name='ReasonPrescribed_3' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='Response_3' name='Response_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='MedicationName_4' name='MedicationName_4' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Dosage_4' name='Dosage_4' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Frequency_4' name='Frequency_4' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='CurrentPast_4' name='CurrentPast_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='ReasonPrescribed_4' name='ReasonPrescribed_4' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='Response_4' name='Response_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='MedicationName_5' name='MedicationName_5' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Dosage_5' name='Dosage_5' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Frequency_5' name='Frequency_5' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='CurrentPast_5' name='CurrentPast_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='ReasonPrescribed_5' name='ReasonPrescribed_5' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='Response_5' name='Response_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='MedicationName_6' name='MedicationName_6' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Dosage_6' name='Dosage_6' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Frequency_6' name='Frequency_6' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='CurrentPast_6' name='CurrentPast_6' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='ReasonPrescribed_6' name='ReasonPrescribed_6' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='Response_6' name='Response_6' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='MedicationName_7' name='MedicationName_7' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Dosage_7' name='Dosage_7' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Frequency_7' name='Frequency_7' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='CurrentPast_7' name='CurrentPast_7' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='ReasonPrescribed_7' name='ReasonPrescribed_7' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='Response_7' name='Response_7' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='MedicationName_8' name='MedicationName_8' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Dosage_8' name='Dosage_8' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Frequency_8' name='Frequency_8' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='CurrentPast_8' name='CurrentPast_8' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='ReasonPrescribed_8' name='ReasonPrescribed_8' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='Response_8' name='Response_8' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='MedicationName_9' name='MedicationName_9' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Dosage_9' name='Dosage_9' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Frequency_9' name='Frequency_9' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='CurrentPast_9' name='CurrentPast_9' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='ReasonPrescribed_9' name='ReasonPrescribed_9' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='Response_9' name='Response_9' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='text' id='MedicationName_10' name='MedicationName_10' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Dosage_10' name='Dosage_10' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='Frequency_10' name='Frequency_10' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='CurrentPast_10' name='CurrentPast_10' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='ReasonPrescribed_10' name='ReasonPrescribed_10' className='add-only' /> </td>
                        <td className='w-125'> <input type='text' id='Response_10' name='Response_10' className='add-only' /> </td>
                    </tr>

                </table>
                <p className='w-750'> <span className='eleHeader'> Are you currently using or interested in the following complimentary health approaches? (Natural products, dietary supplements, naturopathic/homeopathic practices/techniques, acupuncture, massage therapy, meditation/relaxation techniques, yoga/movement therapy techniques?) </span>
                </p>

                <p className='w-750'>
                    <input type='radio' id='rbHealthApproachesYes' name='rbHealthApproaches' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbHealthApproachesNo' name='rbHealthApproaches' className='add-only' value='No' /> No
                </p>

                <p className='w-750'> <span className='eleHeader'> Would the client like to schedule an appointment with agency psychiatrist? </span>
                </p>

                <p className='w-750'>
                    <input type='radio' id='rbPsychiatristYes' name='rbPsychiatrist' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPsychiatristNo' name='rbPsychiatrist' className='add-only' value='No' /> No
                </p>

                <p className='w-750'> <center> <h3> <b> Mental Health History </b> </h3> </center>
                </p>
                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>(1) Current Symptoms/Problems </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Date or Age of Onset </span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtCurrentSymptoms_1' name='txtCurrentSymptoms_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtAge_1' name='txtAge_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'> Behavioral Example of Symptom </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Severity <span className='small'>(mild, moderate, severe, extreme)</span> </span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtBehavioralSymptoms_1' name='txtBehavioralSymptoms_1' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtSeverity_1' name='txtSeverity_1' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>(2) Current Symptoms/Problems </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Date or Age of Onset </span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtCurrentSymptoms_2' name='txtCurrentSymptoms_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtAge_2' name='txtAge_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'> Behavioral Example of Symptom </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Severity <span className='small'>(mild, moderate, severe, extreme)</span> </span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtBehavioralSymptoms_2' name='txtBehavioralSymptoms_2' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtSeverity_2' name='txtSeverity_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>(3) Current Symptoms/Problems </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Date or Age of Onset </span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtCurrentSymptoms_3' name='txtCurrentSymptoms_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtAge_3' name='txtAge_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'> Behavioral Example of Symptom </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Severity <span className='small'>(mild, moderate, severe, extreme)</span> </span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtBehavioralSymptoms_3' name='txtBehavioralSymptoms_3' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtSeverity_3' name='txtSeverity_3' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>(4) Current Symptoms/Problems </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Date or Age of Onset </span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtCurrentSymptoms_5' name='txtCurrentSymptoms_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtAge_5' name='txtAge_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'> Behavioral Example of Symptom </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Severity <span className='small'>(mild, moderate, severe, extreme)</span> </span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtBehavioralSymptoms_5' name='txtBehavioralSymptoms_4' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtSeverity_5' name='txtSeverity_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>(5) Current Symptoms/Problems </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Date or Age of Onset </span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtCurrentSymptoms_5' name='txtCurrentSymptoms_5' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtAge_5' name='txtAge_5' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'> Behavioral Example of Symptom </span> </td>
                        <td className='w-250'> <span className='eleHeader'> Severity <span className='small'>(mild, moderate, severe, extreme)</span> </span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'> <input type='text' id='txtBehavioralSymptoms_5' name='txtBehavioralSymptoms_5' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtSeverity_5' name='txtSeverity_5' className='add-only' /> </td>
                    </tr>

                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Additional Information: </span>
                    <textarea id='txtAdditionalInformation' name='txtAdditionalInformation' className='add-only'></textarea>
                </p>

                <p className='w-750'> <center> <h3> <b> Mental Health History </b> </h3> </center>
                </p>
                <p className='w-750'> <center> <h6> <b> Biological Family </b> </h6> </center>
                </p>

                <p className='w-750'> <span className='eleHeader'> Depression </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbDepressionNa_1' name='cbDepressionNa_1' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbDepressionMother_1' name='cbDepressionMother_1' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbDepressionFather_1' name='cbDepressionFather_1' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbDepressionSister_1' name='cbDepressionSister_1' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbDepressionBrother_1' name='cbDepressionBrother_1' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbDepressionGrdmother_1' name='cbDepressionGrdmother_1' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbDepressionGrdfather_1' name='cbDepressionGrdfather_1' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbDepressionAunt_1' name='cbDepressionAunt_1' className='add-only' value='AuntUncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> Anxiety </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbAnxietyNa_1' name='cbAnxietyNa_1' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbAnxietyMother_1' name='cbAnxietyMother_1' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbAnxietyFather_1' name='cbAnxietyFather_1' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbAnxietySister_1' name='cbAnxietySister_1' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbAnxietyBrother_1' name='cbAnxietyBrother_1' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbAnxietyGrdmother_1' name='cbAnxietyGrdmother_1' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbAnxietyGrdfather_1' name='cbAnxietyGrdfather_1' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbAnxietyAunt_1' name='cbAnxietyAunt_1' className='add-only' value='AuntUncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> Panic </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbPanicNa_1' name='cbPanicNa_1' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbPanicMother_1' name='cbPanicMother_1' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbPanicFather_1' name='cbPanicFather_1' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbPanicSister_1' name='cbPanicSister_1' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbPanicBrother_1' name='cbPanicBrother_1' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbPanicGrdmother_1' name='cbPanicGrdmother_1' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbPanicGrdfather_1' name='cbPanicGrdfather_1' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbPanicAunt_1' name='cbPanicAunt_1' className='add-only' value='AuntUncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> Alcohol/drug Abuse Specify: </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbAlcoholNa_1' name='cbAlcoholNa_1' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbAlcoholMother_1' name='cbAlcoholMother_1' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbAlcoholFather_1' name='cbAlcoholFather_1' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbAlcoholSister_1' name='cbAlcoholSister_1' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbAlcoholBrother_1' name='cbAlcoholBrother_1' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbAlcoholGrdmother_1' name='cbAlcoholGrdmother_1' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbAlcoholGrdfather_1' name='cbAlcoholGrdfather_1' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbAlcoholAunt_1' name='cbAlcoholAunt_1' className='add-only' value='AuntUncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> Eating D.O. Specify: </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbEatingNa_1' name='cbEatingNa_1' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbEatingMother_1' name='cbEatingMother_1' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbEatingFather_1' name='cbEatingFather_1' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbEatingSister_1' name='cbEatingSister_1' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbEatingBrother_1' name='cbEatingBrother_1' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbEatingGrdmother_1' name='cbEatingGrdmother_1' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbEatingGrdfather_1' name='cbEatingGrdfather_1' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbEatingAunt_1' name='cbEatingAunt_1' className='add-only' value='AuntUncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> Bipolar D.O. </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbBipolarNa_1' name='cbBipolarNa_1' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbBipolarMother_1' name='cbBipolarMother_1' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbBipolarFather_1' name='cbBipolarFather_1' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbBipolarSister_1' name='cbBipolarSister_1' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbBipolarBrother_1' name='cbBipolarBrother_1' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbBipolarGrdmother_1' name='cbBipolarGrdmother_1' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbBipolarGrdfather_1' name='cbBipolarGrdfather_1' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbBipolarAunt_1' name='cbBipolarAunt_1' className='add-only' value='AuntUncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> Mania </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbManiaNa_1' name='cbManiaNa_1' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbManiaMother_1' name='cbManiaMother_1' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbManiaFather_1' name='cbManiaFather_1' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbManiaSister_1' name='cbManiaSister_1' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbManiaBrother_1' name='cbManiaBrother_1' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbManiaGrdmother_1' name='cbManiaGrdmother_1' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbManiaGrdfather_1' name='cbManiaGrdfather_1' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbManiaAunt_1' name='cbManiaAunt_1' className='add-only' value='AuntUncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> Schizophrenia </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbSchizophreniaNa_1' name='cbSchizophreniaNa_1' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbSchizophreniaMother_1' name='cbSchizophreniaMother_1' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbSchizophreniaFather_1' name='cbSchizophreniaFather_1' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbSchizophreniaSister_1' name='cbSchizophreniaSister_1' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbSchizophreniaBrother_1' name='cbSchizophreniaBrother_1' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbSchizophreniaGrdmother_1' name='cbSchizophreniaGrdmother_1' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbSchizophreniaGrdfather_1' name='cbSchizophreniaGrdfather_1' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbSchizophreniaAunt_1' name='cbSchizophreniaAunt_1' className='add-only' value='AuntUncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> Paranoia </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbParanoiaNa_1' name='cbParanoiaNa_1' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbParanoiaMother_1' name='cbParanoiaMother_1' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbParanoiaFather_1' name='cbParanoiaFather_1' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbParanoiaSister_1' name='cbParanoiaSister_1' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbParanoiaBrother_1' name='cbParanoiaBrother_1' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbParanoiaGrdmother_1' name='cbParanoiaGrdmother_1' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbParanoiaGrdfather_1' name='cbParanoiaGrdfather_1' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbParanoiaAunt_1' name='cbParanoiaAunt_1' className='add-only' value='AuntUncle' /> Aunt/Uncle
                </p>
                <p className='w-750'> <span className='eleHeader'> Learning Disability Specify: </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbDisabilityNa_1' name='cbDisabilityNa_1' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbDisabilityMother_1' name='cbDisabilityMother_1' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbDisabilityFather_1' name='cbDisabilityFather_1' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='DisabilitySister_1' name='DisabilitySister_1' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='DisabilityBrother_1' name='DisabilityBrother_1' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='DisabilityGrdmother_1' name='DisabilityGrdmother_1' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='DisabilityGrdfather_1' name='DisabilityGrdfather_1' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='DisabilityAunt_1' name='DisabilityAunt_1' className='add-only' value='AuntUncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> ADHD </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbAdhdNa_1' name='cbAdhdNa_1' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbAdhdMother_1' name='cbAdhdMother_1' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbAdhdFather_1' name='cbAdhdFather_1' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbAdhdSister_1' name='cbAdhdSister_1' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbAdhdBrother_1' name='cbAdhdBrother_1' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbAdhdGrdmother_1' name='cbAdhdGrdmother_1' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbAdhdGrdfather_1' name='cbAdhdGrdfather_1' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbAdhdAunt_1' name='cbAdhdAunt_1' className='add-only' value='AuntUncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <center> <h3> <b> Mental Health History </b> </h3> </center>
                </p>
                <p className='w-750'> <center> <h6> <b> Adopted or Foster Family </b> </h6> </center>
                </p>

                <p className='w-750'> <span className='eleHeader'> Depression </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbDepressionNa_2' name='cbDepressionNa_2' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbDepressionMother_2' name='cbDepressionMother_2' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbDepressionFather_2' name='cbDepressionFather_2' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbDepressionSister_2' name='cbDepressionSister_2' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbDepressionBrother_2' name='cbDepressionBrother_2' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbDepressionGrdmother_2' name='cbDepressionGrdmother_2' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbDepressionGrdfather_2' name='cbDepressionGrdfather_2' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbDepressionAunt_2' name='cbDepressionAunt_2' className='add-only' value='Aunt/Uncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> Anxiety </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbAnxietyNa_2' name='cbAnxietyNa_2' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbAnxietyMother_2' name='cbAnxietyMother_2' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbAnxietyFather_2' name='cbAnxietyFather_2' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbAnxietySister_2' name='cbAnxietySister_2' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbAnxietyBrother_2' name='cbAnxietyBrother_2' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbAnxietyGrdmother_2' name='cbAnxietyGrdmother_2' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbAnxietyGrdfather_2' name='cbAnxietyGrdfather_2' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbAnxietyAunt_2' name='cbAnxietyAunt_2' className='add-only' value='Aunt/Uncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> Panic </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbPanicNa_2' name='cbPanicNa_2' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbPanicMother_2' name='cbPanicMother_2' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbPanicFather_2' name='cbPanicFather_2' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbPanicSister_2' name='cbPanicSister_2' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbPanicBrother_2' name='cbPanicBrother_2' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbPanicGrdmother_2' name='cbPanicGrdmother_2' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbPanicGrdfather_2' name='cbPanicGrdfather_2' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbPanicAunt_2' name='cbPanicAunt_2' className='add-only' value='Aunt/Uncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> Alcohol/drug Abuse Specify: </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbAlcoholNa_2' name='cbAlcoholNa_2' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbAlcoholMother_2' name='cbAlcoholMother_2' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbAlcoholFather_2' name='cbAlcoholFather_2' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbAlcoholSister_2' name='cbAlcoholSister_2' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbAlcoholBrother_2' name='cbAlcoholBrother_2' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbAlcoholGrdmother_2' name='cbAlcoholGrdmother_2' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbAlcoholGrdfather_2' name='cbAlcoholGrdfather_2' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbAlcoholAunt_2' name='cbAlcoholAunt_2' className='add-only' value='Aunt/Uncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> Eating D.O. Specify: </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbEatingNa_2' name='cbEatingNa_2' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbEatingMother_2' name='cbEatingMother_2' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbEatingFather_2' name='cbEatingFather_2' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbEatingSister_2' name='cbEatingSister_2' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbEatingBrother_2' name='cbEatingBrother_2' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbEatingGrdmother_2' name='cbEatingGrdmother_2' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbEatingGrdfather_2' name='cbEatingGrdfather_2' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbEatingAunt_2' name='cbEatingAunt_2' className='add-only' value='Aunt/Uncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> Bipolar D.O. </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbBipolarNa_2' name='cbBipolarNa_2' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbBipolarMother_2' name='cbBipolarMother_2' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbBipolarFather_2' name='cbBipolarFather_2' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbBipolarSister_2' name='cbBipolarSister_2' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbBipolarBrother_2' name='cbBipolarBrother_2' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbBipolarGrdmother_2' name='cbBipolarGrdmother_2' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbBipolarGrdfather_2' name='cbBipolarGrdfather_2' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbBipolarAunt_2' name='cbBipolarAunt_2' className='add-only' value='Aunt/Uncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> Mania </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbManiaNa_2' name='cbManiaNa_2' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbManiaMother_2' name='cbManiaMother_2' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbManiaFather_2' name='cbManiaFather_2' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbManiaSister_2' name='cbManiaSister_2' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbManiaBrother_2' name='cbManiaBrother_2' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbManiaGrdmother_2' name='cbManiaGrdmother_2' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbManiaGrdfather_2' name='cbManiaGrdfather_2' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbManiaAunt_2' name='cbManiaAunt_2' className='add-only' value='Aunt/Uncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> Schizophrenia </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbSchizophreniaNa_2' name='cbSchizophreniaNa_2' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbSchizophreniaMother_2' name='cbSchizophreniaMother_2' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbSchizophreniaFather_2' name='cbSchizophreniaFather_2' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbSchizophreniaSister_2' name='cbSchizophreniaSister_2' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbSchizophreniaBrother_2' name='cbSchizophreniaBrother_2' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbSchizophreniaGrdmother_2' name='cbSchizophreniaGrdmother_2' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbSchizophreniaGrdfather_2' name='cbSchizophreniaGrdfather_2' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbSchizophreniaAunt_2' name='cbSchizophreniaAunt_2' className='add-only' value='Aunt/Uncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> Paranoia </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbParanoiaNa_2' name='cbParanoiaNa_2' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbParanoiaMother_2' name='cbParanoiaMother_2' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbParanoiaFather_2' name='cbParanoiaFather_2' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbParanoiaSister_2' name='cbParanoiaSister_2' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbParanoiaBrother_2' name='cbParanoiaBrother_2' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbParanoiaGrdmother_2' name='cbParanoiaGrdmother_2' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbParanoiaGrdfather_2' name='cbParanoiaGrdfather_2' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbParanoiaAunt_2' name='cbParanoiaAunt_2' className='add-only' value='Aunt/Uncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> Learning Disability Specify: </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbDisabilityNa_2' name='cbDisabilityNa_2' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbDisabilityMother_2' name='cbDisabilityMother_2' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbDisabilityFather_2' name='cbDisabilityFather_2' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='DisabilitySister_2' name='DisabilitySister_2' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='DisabilityBrother_2' name='DisabilityBrother_2' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='DisabilityGrdmother_2' name='DisabilityGrdmother_2' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='DisabilityGrdfather_2' name='DisabilityGrdfather_2' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='DisabilityAunt_2' name='DisabilityAunt_2' className='add-only' value='Aunt/Uncle' /> Aunt/Uncle
                </p>

                <p className='w-750'> <span className='eleHeader'> ADHD </span>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbAdhdNa_2' name='cbAdhdNa_2' className='add-only' value='Na' /> N/A &nbsp;
                    <input type='checkbox' id='cbAdhdMother_2' name='cbAdhdMother_2' className='add-only' value='Mother' /> Mother &nbsp;
                    <input type='checkbox' id='cbAdhdFather_2' name='cbAdhdFather_2' className='add-only' value='Father' /> Father &nbsp;
                    <input type='checkbox' id='cbAdhdSister_2' name='cbAdhdSister_2' className='add-only' value='Sisters' /> Sister/s &nbsp;
                    <input type='checkbox' id='cbAdhdBrother_2' name='cbAdhdBrother_2' className='add-only' value='Brothers' /> Brother/s &nbsp;
                    <input type='checkbox' id='cbAdhdGrdmother_2' name='cbAdhdGrdmother_2' className='add-only' value='Grdmother' /> Grdmother &nbsp;
                    <input type='checkbox' id='cbAdhdGrdfather_2' name='cbAdhdGrdfather_2' className='add-only' value='Grdfather' /> Grdfather &nbsp;
                    <input type='checkbox' id='cbAdhdAunt_2' name='cbAdhdAunt_2' className='add-only' value='Aunt/Uncle' /> Aunt/Uncle
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Trauma History </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNoneReported' name='cbNoneReported' className='add-only' value='NoneReported' /> None Reported </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbExperienced' name='cbExperienced' className='add-only' value='Experienced' /> Experienced </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbWitnessed' name='cbWitnessed' className='add-only' value='Witnessed' /> Witnessed </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPhysicalAbuse' name='cbPhysicalAbuse' className='add-only' value='PhysicalAbuse' /> Physical Abuse </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSexualAbuse' name='cbSexualAbuse' className='add-only' value='SexualAbuse' /> Sexual Abuse </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEmotionalAbuse' name='cbEmotionalAbuse' className='add-only' value='EmotionalAbuse' /> Emotional Abuse </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNeglect' name='cbNeglect' className='add-only' value='Neglect' /> Neglect </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherDescribe' name='cbOtherDescribe' className='add-only' value='OtherDescribe' /> Other/Describe ::
                            &nbsp;
                            <input type='text' id='txtOtherDescribe' name='txtOtherDescribe' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Other Relevant History</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-750'>Relevant loss/separation, significant illness, traumatic events, house fires, loss of pets, abuse//neglect of parents/caregivers, siblings, etc. </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNoneReportedOrDenied' name='cbNoneReportedOrDenied' className='add-only' value='NoneReportedOrDenied' /> None Reported or Denied </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date or Age</span>
                        </td>

                        <td className='w-500'>
                            <span className='eleHeader'>Description</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtDateOrAge_1' name='txtDateOrAge_1' className='add-only' />
                        </td>
                        <td className='w-500'><input type='text' id='txtDescription_1' name='txtDescription_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtDateOrAge_2' name='txtDateOrAge_2' className='add-only' />
                        </td>
                        <td className='w-500'><input type='text' id='txtDescription_2' name='txtDescription_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtDateOrAge_3' name='txtDateOrAge_3' className='add-only' />
                        </td>
                        <td className='w-500'><input type='text' id='txtDescription_3' name='txtDescription_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtDateOrAge_4' name='txtDateOrAge_4' className='add-only' />
                        </td>
                        <td className='w-500'><input type='text' id='txtDescription_4' name='txtDescription_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtDateOrAge_5' name='txtDateOrAge_5' className='add-only' />
                        </td>
                        <td className='w-500'><input type='text' id='txtDescription_5' name='txtDescription_5' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtDateOrAge_6' name='txtDateOrAge_6' className='add-only' />
                        </td>
                        <td className='w-500'><input type='text' id='txtDescription_6' name='txtDescription_6' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtDateOrAge_7' name='txtDateOrAge_7' className='add-only' />
                        </td>
                        <td className='w-500'><input type='text' id='txtDescription_7' name='txtDescription_7' className='add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Do you feel safe at home? </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbYes_1' name='rbDoYouFeelSafeAtHome' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbNo_1' name='rbDoYouFeelSafeAtHome' className='add-only' value='No' /> No &nbsp;
                            <input type='radio' id='rbNotAlways' name='rbDoYouFeelSafeAtHome' className='add-only' value='NotAlways' /> Not Always</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>What do you like about your relationships with the people in your home? </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtWhatDoYouLikeAboutYourRelationshipsWithThePeopleInYourHome' name='txtWhatDoYouLikeAboutYourRelationshipsWithThePeopleInYourHome' className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If you could change something or one thing with your relationships, what would it be? </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtIfYouCouldChangeSomethingOrOneThingWithYourRelationshipsWhatWouldItBe' name='txtIfYouCouldChangeSomethingOrOneThingWithYourRelationshipsWhatWouldItBe' className='add-only'></textarea>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Discrimination/Oppression </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNoneReportedOrDenied_1' name='cbNoneReportedOrDenied_1' className='add-only' value='NoneReportedOrDenied' /> None Reported or Denied </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBullying' name='cbBullying' className='add-only' value='Bullying' /> Bullying </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCulturalEthicBias' name='cbCulturalEthicBias' className='add-only' value='CulturalEthicBias' /> Cultural ethic bias </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAntiSemitism' name='cbAntiSemitism' className='add-only' value='AntiSemitism' /> Anti-Semitism </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIslamophobia' name='cbIslamophobia' className='add-only' value='Islamophobia' /> Islamophobia </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRacism' name='cbRacism' className='add-only' value='Racism' /> Racism </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHomophobia' name='cbHomophobia' className='add-only' value='Homophobia' /> Homophobia </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTransphobia' name='cbTransphobia' className='add-only' value='Transphobia' /> Transphobia </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFatShaming' name='cbFatShaming' className='add-only' value='FatShaming' /> Fat Shaming </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRacialProfiling' name='cbRacialProfiling' className='add-only' value='RacialProfiling' /> Racial profiling </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbDiscriminationOther' name='cbDiscriminationOther' className='add-only' value='DiscriminationOther' /> Other:
                            &nbsp;
                            <input type='text' id='txtDiscriminationOther' name='txtDiscriminationOther' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Supporting Information: </span>
                    <textarea id='txtSupportingInformation' name='txtSupportingInformation' className='add-only'></textarea>
                </p>
                <p className='w-750'><h2>Self Harm & Risk Assessment</h2></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Substance Use/Abuse History</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbNoneReportedOrDenied_3' name='cbNoneReportedOrDenied_3' className='add-only' value='NoneReportedOrDenied' /> None Reported or Denied
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>The following was reported</span>
                        </td>
                        <td className='w-75'>
                            <span className='eleHeader'>Age of Onset</span>
                        </td>
                        <td className='w-425'>
                            <span className='eleHeader'>Frequency, intensity, duration, any other relevant information</span>
                        </td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAlcoholUse' name='cbAlcoholUse' className='add-only' value='AlcoholUse' /> Alcohol Use</td>
                        <td className='w-75'>
                            <input type='text' id='AgeOfOnset_1' name='AgeOfOnset_1' className='add-only' />
                        </td>
                        <td className='w-425'>
                            <input type='text' id='txtFrequencyIntensityDurationAnyOtherRelevantInformation_1' name='txtFrequencyIntensityDurationAnyOtherRelevantInformation_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCaffeineUse' name='cbCaffeineUse' className='add-only' value='CaffeineUse' /> Caffeine Use</td>
                        <td className='w-75'>
                            <input type='text' id='AgeOfOnset_2' name='AgeOfOnset_2' className='add-only' />
                        </td>
                        <td className='w-425'>
                            <input type='text' id='txtFrequencyIntensityDurationAnyOtherRelevantInformation_2' name='txtFrequencyIntensityDurationAnyOtherRelevantInformation_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPrescriptionRxDrugAbuse' name='cbPrescriptionRxDrugAbuse' className='add-only' value='PrescriptionRxDrugAbuse' /> Prescription (Rx) Drug Abuse</td>
                        <td className='w-75'>
                            <input type='text' id='AgeOfOnset_3' name='AgeOfOnset_3' className='add-only' />
                        </td>
                        <td className='w-425'>
                            <input type='text' id='txtFrequencyIntensityDurationAnyOtherRelevantInformation_3' name='txtFrequencyIntensityDurationAnyOtherRelevantInformation_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNonRxOtcDrugAbuse' name='cbNonRxOtcDrugAbuse' className='add-only' value='NonRxOtcDrugAbuse' /> Non-Rx (OTC) Drug Abuse</td>
                        <td className='w-75'>
                            <input type='text' id='AgeOfOnset_4' name='AgeOfOnset_4' className='add-only' />
                        </td>
                        <td className='w-425'>
                            <input type='text' id='txtFrequencyIntensityDurationAnyOtherRelevantInformation_4' name='txtFrequencyIntensityDurationAnyOtherRelevantInformation_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAlcoholAndOrDrugOverdoses' name='cbAlcoholAndOrDrugOverdoses' className='add-only' value='AlcoholAndOrDrugOverdoses' /> Alcohol and/or Drug Overdoses</td>
                        <td className='w-75'>
                            <input type='text' id='AgeOfOnset_5' name='AgeOfOnset_5' className='add-only' />
                        </td>
                        <td className='w-425'>
                            <input type='text' id='txtFrequencyIntensityDurationAnyOtherRelevantInformation_5' name='txtFrequencyIntensityDurationAnyOtherRelevantInformation_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAlcoholAndOrDrugBlackouts' name='cbAlcoholAndOrDrugBlackouts' className='add-only' value='AlcoholAndOrDrugBlackouts' /> Alcohol and/or Drug Blackouts</td>

                        <td className='w-75'>
                            <input type='text' id='AgeOfOnset_6' name='AgeOfOnset_6' className='add-only' />
                        </td>
                        <td className='w-425'>
                            <input type='text' id='txtFrequencyIntensityDurationAnyOtherRelevantInformation_6' name='txtFrequencyIntensityDurationAnyOtherRelevantInformation_6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAlcoholAndOrDrugWithdrawals' name='cbAlcoholAndOrDrugWithdrawals' className='add-only' value='AlcoholAndOrDrugWithdrawals' /> Alcohol and/or Drug Withdrawals</td>
                        <td className='w-75'>
                            <input type='text' id='AgeOfOnset_7' name='AgeOfOnset_7' className='add-only' />
                        </td>
                        <td className='w-425'>
                            <input type='text' id='txtFrequencyIntensityDurationAnyOtherRelevantInformation_7' name='txtFrequencyIntensityDurationAnyOtherRelevantInformation_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTroubleStoppingAnySubstance' name='cbTroubleStoppingAnySubstance' className='add-only' value='TroubleStoppingAnySubstance' /> Trouble stopping any substance</td>
                        <td className='w-75'>
                            <input type='text' id='AgeOfOnset_8' name='AgeOfOnset_8' className='add-only' />
                        </td>
                        <td className='w-425'>
                            <input type='text' id='txtFrequencyIntensityDurationAnyOtherRelevantInformation_8' name='txtFrequencyIntensityDurationAnyOtherRelevantInformation_8' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTobaccoUse' name='cbTobaccoUse' className='add-only' value='TobaccoUse' /> Tobacco Use</td>
                        <td className='w-75'>
                            <input type='text' id='AgeOfOnset_9' name='AgeOfOnset_9' className='add-only' />
                        </td>
                        <td className='w-425'>
                            <input type='text' id='txtFrequencyIntensityDurationAnyOtherRelevantInformation_9' name='txtFrequencyIntensityDurationAnyOtherRelevantInformation_9' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProblemsCausedByGambling' name='cbProblemsCausedByGambling' className='add-only' value='ProblemsCausedByGambling' /> Problems Caused by Gambling</td>
                        <td className='w-75'>
                            <input type='text' id='AgeOfOnset_10' name='AgeOfOnset_10' className='add-only' />
                        </td>
                        <td className='w-425'>
                            <input type='text' id='txtFrequencyIntensityDurationAnyOtherRelevantInformation_10' name='txtFrequencyIntensityDurationAnyOtherRelevantInformation_10' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIllegalDrugUse_2' name='cbIllegalDrugUse_2' className='add-only' value='IllegalDrugUse' /> Illegal Drug Use:</td>
                        <td className='w-75'>
                            <input type='text' id='AgeOfOnset_11' name='AgeOfOnset_11' className='add-only' />
                        </td>
                        <td className='w-425'>
                            <input type='text' id='txtFrequencyIntensityDurationAnyOtherRelevantInformation_11' name='txtFrequencyIntensityDurationAnyOtherRelevantInformation_11' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Substance Use Treatment History</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNone_2' name='cbNone_2' className='add-only' value='None' /> None</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOutpatient' name='cbOutpatient' className='add-only' value='Outpatient' /> Outpatient </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIntensiveOutpatient' name='cbIntensiveOutpatient' className='add-only' value='IntensiveOutpatient' /> Intensive Outpatient</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbResidentialInpatient' name='cbResidentialInpatient' className='add-only' value='ResidentialInpatient' /> Residential/Inpatient</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDetox' name='cbDetox' className='add-only' value='Detox' /> Detox </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTreaatmentHistoryOther' name='cbTreaatmentHistoryOther' className='add-only' value='TreaatmentHistoryOther' /> Other:
                            &nbsp;
                            <input type='text' id='txtTreaatmentHistoryOther' name='txtTreaatmentHistoryOther' className='add-only w-250 custom-add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Has anyone ever commented on your substance use?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='Yes' name='rbHasAnyoneEverCommentedOnYourSubstanceUse' className='add-only' value='Yes' /> YES &nbsp;
                            <input type='radio' id='No' name='rbHasAnyoneEverCommentedOnYourSubstanceUse' className='add-only' value='No' /> NO
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Are you concerned about any substance use?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='Yes' name='rbAreYouConcernedAboutAnySubstanceUse' className='add-only' value='Yes' /> YES &nbsp;
                            <input type='radio' id='No' name='rbAreYouConcernedAboutAnySubstanceUse' className='add-only' value='No' /> NO
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Past Suicide Attempts/or Suicidal Ideation</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type='checkbox' id='cbNoneReportedOrObserved' name='cbNoneReportedOrObserved' className='add-only' value='NoneReportedOrObserved' /> None Reported or Observed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date &/or Age</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Relevant Information</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Follow-up or Result</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtAgeOrDate' name='txtAgeOrDate' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRelevantInformation' name='txtRelevantInformation' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtFollowUpResult' name='txtFollowUpResult' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtAgeOrDate_1' name='txtAgeOrDate_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRelevantInformation_1' name='txtRelevantInformation_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtFollowUpResult_1' name='txtFollowUpResult_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtAgeOrDate_2' name='txtAgeOrDate_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRelevantInformation_2' name='txtRelevantInformation_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtFollowUpResult_2' name='txtFollowUpResult_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtAgeOrDate_3' name='txtAgeOrDate_3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRelevantInformation_3' name='txtRelevantInformation_3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtFollowUpResult_3' name='txtFollowUpResult_3' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h2>Current Risk Assessment to Self or Others</h2>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Suicide</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNa' name='cbNa' className='add-only' value='Na' /> N/A
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIdeation' name='cbIdeation' className='add-only' value='Ideation' /> Ideation
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIntent' name='cbIntent' className='add-only' value='Intent' /> Intent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPlan' name='cbPlan' className='add-only' value='Plan' /> Plan
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMeans' name='cbMeans' className='add-only' value='Means' /> Means
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssess' name='cbAssess' className='add-only' value='Assess' /> Assess
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLow' name='cbLow' className='add-only' value='Low' /> Low
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed' name='cbMed' className='add-only' value='Med' /> Med
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHigh' name='cbHigh' className='add-only' value='High' /> High*
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Homicide</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNa_1' name='cbNa_1' className='add-only' value='Na' /> N/A
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIdeation_1' name='cbIdeation_1' className='add-only' value='Ideation' /> Ideation
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIntent_1' name='cbIntent_1' className='add-only' value='Intent' /> Intent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPlan_1' name='cbPlan_1' className='add-only' value='Plan' /> Plan
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMeans_1' name='cbMeans_1' className='add-only' value='Means' /> Means
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssess_1' name='cbAssess_1' className='add-only' value='Assess' /> Assess
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLow_1' name='cbLow_1' className='add-only' value='Low' /> Low
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_1' name='cbMed_1' className='add-only' value='Med' /> Med
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHigh_1' name='cbHigh_1' className='add-only' value='High' /> High*
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Assault</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNa_2' name='cbNa_2' className='add-only' value='Na' /> N/A
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIdeation_2' name='cbIdeation_2' className='add-only' value='Ideation' /> Ideation
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIntent_2' name='cbIntent_2' className='add-only' value='Intent' /> Intent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPlan_2' name='cbPlan_2' className='add-only' value='Plan' /> Plan
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMeans_2' name='cbMeans_2' className='add-only' value='Means' /> Means
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssess_2' name='cbAssess_2' className='add-only' value='Assess' /> Assess
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLow_2' name='cbLow_2' className='add-only' value='Low' /> Low
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_2' name='cbMed_2' className='add-only' value='Med' /> Med
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHigh_2' name='cbHigh_2' className='add-only' value='High' /> High*
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Violence</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNa_3' name='cbNa_3' className='add-only' value='Na' /> N/A
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIdeation_3' name='cbIdeation_3' className='add-only' value='Ideation' /> Ideation
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIntent_3' name='cbIntent_3' className='add-only' value='Intent' /> Intent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPlan_3' name='cbPlan_3' className='add-only' value='Plan' /> Plan
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMeans_3' name='cbMeans_3' className='add-only' value='Means' /> Means
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssess_3' name='cbAssess_3' className='add-only' value='Assess' /> Assess
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLow_3' name='cbLow_3' className='add-only' value='Low' /> Low
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_3' name='cbMed_3' className='add-only' value='Med' /> Med
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHigh_3' name='cbHigh_3' className='add-only' value='High' /> High*
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Other:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNa_4' name='cbNa_4' className='add-only' value='Na' /> N/A
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIdeation_4' name='cbIdeation_4' className='add-only' value='Ideation' /> Ideation
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIntent_4' name='cbIntent_4' className='add-only' value='Intent' /> Intent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPlan_4' name='cbPlan_4' className='add-only' value='Plan' /> Plan
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMeans_4' name='cbMeans_4' className='add-only' value='Means' /> Means
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssess_4' name='cbAssess_4' className='add-only' value='Assess' /> Assess
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLow_4' name='cbLow_4' className='add-only' value='Low' /> Low
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMed_4' name='cbMed_4' className='add-only' value='Med' /> Med
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHigh_4' name='cbHigh_4' className='add-only' value='High' /> High*
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Other SelfHarm Behaviors:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCutting' name='cbCutting' className='add-only' value='Cutting' /> Cutting
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbBingeing' name='cbBingeing' className='add-only' value='Bingeing' /> Bingeing
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPurging' name='cbPurging' className='add-only' value='Purging' /> Purging
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCompulsiveSex' name='cbCompulsiveSex' className='add-only' value='CompulsiveSex' /> Compulsive sex
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCompulsiveShopping' name='cbCompulsiveShopping' className='add-only' value='CompulsiveShopping' /> Compulsive shopping
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOther_147' name='cbOther_147' className='add-only' value='Other_147' /> Other:
                            &nbsp;
                            <input type='text' id='txtOther_147' name='txtOther_147' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Frequency:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Intensity:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Duration:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtFrequency' name='txtFrequency' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtIntensity' name='txtIntensity' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtDuration' name='txtDuration' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h2>Individualized Safety/ Crisis Recovery Plan</h2>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>What constitutes a crisis for me/ What does a crisis look like for me?</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Describe events/situations that may be precipitants to a crisis related event: (Triggers)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtWhatConstitutesCrisisForMe' name='txtWhatConstitutesCrisisForMe' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtDescribeEventsSituationsThatMayBePrecipitants' name='txtDescribeEventsSituationsThatMayBePrecipitants' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>What are some warning signs/symptoms that alerts others that I am having a difficult time</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Describe what actions can be taken by me, my family or natural supports to address crisis:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtWhatAreSomeWarningSignsSymptoms' name='txtWhatAreSomeWarningSignsSymptoms' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtDescribeWhatActionsCanBeTakenByMe' name='txtDescribeWhatActionsCanBeTakenByMe' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>What can my MHR Provider do to help me when in crisis:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Name, Title, and contact numbers for provider staff: James P. Jenkins Jr., LPC-S</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtWhatCanMyMhrProviderDoToHelp' name='txtWhatCanMyMhrProviderDoToHelp' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtNameTitleAndContactNumbersFor' name='txtNameTitleAndContactNumbersFor' className='add-only' defaultValue='Emergency Number: 318-754-3890' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Who do I prefer to help me when entering a crisis: Name, address and contact number:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>What coping strategies work or me:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtWhoDoIPreferToHelpMeWhenEntering' name='txtWhoDoIPreferToHelpMeWhenEntering' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtWhatCopingStrategiesWorkOrMe' name='txtWhatCopingStrategiesWorkOrMe' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Screening Tools Used to Support Diagnosis:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>DSM-5 Self- Rated Level 1</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtScreeningToolsUsedToSupport' name='txtScreeningToolsUsedToSupport' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtDsmSelfRatedLevel' name='txtDsmSelfRatedLevel' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h2>Goals for Services (Counseling, CPST, PSR)</h2>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> What three changes would you like to get out of being in services? Consider family relationships, school, work, and general functioning in your daily life.</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtWhatThreeChangesWouldYouLikeToGetOutOfBeingInServices' name='txtWhatThreeChangesWouldYouLikeToGetOutOfBeingInServices' className='add-only'></textarea>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h2>
                        Diagnostic Formulation
                    </h2>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Identifying Information</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtIdentifyingInformation' name='txtIdentifyingInformation' className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Reasons client is seeking services</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtReasonsClientIsSeekingServices' name='txtReasonsClientIsSeekingServices' className='add-only'></textarea>
                        </td>
                    </tr> <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Strengths and Motivation (Client's hope for recovery)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtStrengthsAndMotivation' name='txtStrengthsAndMotivation' className='add-only'></textarea>
                        </td>
                    </tr> <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Barriers to Treatment (bio-psych-social-stressors and their impact on symptoms/functioning) (Z Codes/V Codes)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtBarriersToTreatmentOne' name='txtBarriersToTreatmentOne' className='add-only'></textarea>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>The client displays severe impairment in the following areas:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdls' name='cbAdls' className='add-only' value='Adls' /> ADLs
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCommunityLiving' name='cbCommunityLiving' className='add-only' value='CommunityLiving' /> Community Living
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbFamilyRelationships' name='cbFamilyRelationships' className='add-only' value='FamilyRelationships' /> Family Relationships
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbWorkPerformance' name='cbWorkPerformance' className='add-only' value='WorkPerformance' /> Work Performance
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSocialRelationships' name='cbSocialRelationships' className='add-only' value='SocialRelationships' /> Social Relationships
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Community resources recommended or involved. </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtCommunityResourcesRecommended' name='txtCommunityResourcesRecommended' className='add-only'></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Level of Care/ Duration </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtLevelOfCareDuration' name='txtLevelOfCareDuration' className='add-only'></textarea>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Expected Outcome and Prognosis </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbReturnToNormalFunction' name='cbReturnToNormalFunction' className='add-only' value='ReturnToNormalFunction' /> Return to normal function
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMaintainCurrentStatusPreventDeterioration' name='cbMaintainCurrentStatusPreventDeterioration' className='add-only' value='MaintainCurrentStatusPreventDeterioration' /> Maintain current status, prevent deterioration
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbRelieveAcuteSymptomsReturnToBaselineFunctioning' name='cbRelieveAcuteSymptomsReturnToBaselineFunctioning' className='add-only' value='RelieveAcuteSymptomsReturnToBaselineFunctioning' /> Relieve acute symptoms, return to baseline functioning
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbExpectImprovementAnticipateLessThanNormalFunctioning' name='cbExpectImprovementAnticipateLessThanNormalFunctioning' className='add-only' value='ExpectImprovementAnticipateLessThanNormalFunctioning' /> Expect improvement, anticipate less than normal functioning
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Identified Needs </span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> Objective (in client's own words) SMART </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtIdentifiedNeeds_1' name='txtIdentifiedNeeds_1' /></td>
                        <td className='w-375'><input type='text' id='txtObjectivesInCkientWordsSmart_1' name='txtObjectivesInCkientWordsSmart_1' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtIdentifiedNeeds_2' name='txtIdentifiedNeeds_2' /></td>
                        <td className='w-375'><input type='text' id='txtObjectivesInCkientWordsSmart_2' name='txtObjectivesInCkientWordsSmart_2' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtIdentifiedNeeds_3' name='txtIdentifiedNeeds_3' /></td>
                        <td className='w-375'><input type='text' id='txtObjectivesInCkientWordsSmart_3' name='txtObjectivesInCkientWordsSmart_3' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtIdentifiedNeeds_4' name='txtIdentifiedNeeds_4' /></td>
                        <td className='w-375'><input type='text' id='txtObjectivesInCkientWordsSmart_4' name='txtObjectivesInCkientWordsSmart_4' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtIdentifiedNeeds_5' name='txtIdentifiedNeeds_5' /></td>
                        <td className='w-375'><input type='text' id='txtObjectivesInCkientWordsSmart_5' name='txtObjectivesInCkientWordsSmart_5' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtIdentifiedNeeds_6' name='txtIdentifiedNeeds_6' /></td>
                        <td className='w-375'><input type='text' id='txtObjectivesInCkientWordsSmart_6' name='txtObjectivesInCkientWordsSmart_6' /></td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h2>
                        Current Mental Status Examination
                    </h2>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> General Appearance </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHealthy' name='cbHealthy' className='add-only' value='Healthy' /> Healthy
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAsStatedAge' name='cbAsStatedAge' className='add-only' value='AsStatedAge' /> As Stated Age
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOlderThanStatedAge' name='cbOlderThanStatedAge' className='add-only' value='OlderThanStatedAge' /> Older Than Stated Age
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbYoungLooking' name='cbYoungLooking' className='add-only' value='YoungLooking' /> Young-looking
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTattoos' name='cbTattoos' className='add-only' value='Tattoos' /> Tattoos
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDisheveled' name='cbDisheveled' className='add-only' value='Disheveled' /> Disheveled
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbUnkempt' name='cbUnkempt' className='add-only' value='Unkempt' /> Unkempt
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMalodorous' name='cbMalodorous' className='add-only' value='Malodorous' /> Malodorous
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThin' name='cbThin' className='add-only' value='Thin' /> Thin
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOverWeight' name='cbOverWeight' className='add-only' value='OverWeight' /> Overweight
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbObese' name='cbObese' className='add-only' value='Obese' /> Obese
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherDescribe_2' name='cbOtherDescribe_2' className='add-only' value='OtherDescribe_2' /> Other/Describe :
                            &nbsp;
                            <input type='text' id='txtOtherDescribe_2' name='txtOtherDescribe_2' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Behavior & Psychomotor Activity </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNormal_1' name='cbNormal_1' className='add-only' value='Normal_1' /> Normal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOveractive' name='cbOveractive' className='add-only' value='Overactive' /> Overactive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHypoactive' name='cbHypoactive' className='add-only' value='Hypoactive' /> Hypoactive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCatatonia' name='cbCatatonia' className='add-only' value='Catatonia' /> Catatonia
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTremor' name='cbTremor' className='add-only' value='Tremor' /> Tremor
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTics' name='cbTics' className='add-only' value='Tics' /> Tics
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCombative' name='cbCombative' className='add-only' value='Combative' /> Combative
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherDescribe_3' name='cbOtherDescribe_3' className='add-only' value='OtherDescribe_3' /> Other/Describe :
                            &nbsp;
                            <input type='text' id='txtOtherDescribe_3' name='txtOtherDescribe_3' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Attitude </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOptimal' name='cbOptimal' className='add-only' value='Optimal' /> Optimal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbConstructive' name='cbConstructive' className='add-only' value='Constructive' /> Constructive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMotivated' name='cbMotivated' className='add-only' value='Motivated' /> Motivated
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbObstructive' name='cbObstructive' className='add-only' value='Obstructive' /> Obstructive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAdversarial' name='cbAdversarial' className='add-only' value='Adversarial' /> Adversarial
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbInaccessible' name='cbInaccessible' className='add-only' value='Inaccessible' /> Inaccessible
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCooperative' name='cbCooperative' className='add-only' value='Cooperative' /> Cooperative
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSeductive' name='cbSeductive' className='add-only' value='Seductive' /> Seductive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDefensive' name='cbDefensive' className='add-only' value='Defensive' /> Defensive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHostile' name='cbHostile' className='add-only' value='Hostile' /> Hostile
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbGuarded' name='cbGuarded' className='add-only' value='Guarded' /> Guarded
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbApathetic' name='cbApathetic' className='add-only' value='Apathetic' /> Apathetic
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEvasive' name='cbEvasive' className='add-only' value='Evasive' /> Evasive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherDescribe_4' name='cbOtherDescribe_4' className='add-only' value='OtherDescribe_4' /> Other/Describe :
                            &nbsp;
                            <input type='text' id='txtOtherDescribe_4' name='txtOtherDescribe_4' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Mood </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDysphoric' name='cbDysphoric' className='add-only' value='Dysphoric' /> Dysphoric
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEuthymic' name='cbEuthymic' className='add-only' value='Euthymic' /> Euthymic
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbExpansive' name='cbExpansive' className='add-only' value='Expansive' /> Expansive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIrritable' name='cbIrritable' className='add-only' value='Irritable' /> Irritable
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLabile' name='cbLabile' className='add-only' value='Labile' /> Labile
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbElevated' name='cbElevated' className='add-only' value='Elevated' /> Elevated
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEuphoric' name='cbEuphoric' className='add-only' value='Euphoric' /> Euphoric
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEcstatic' name='cbEcstatic' className='add-only' value='Ecstatic' /> Ecstatic
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepressed' name='cbDepressed' className='add-only' value='Depressed' /> Depressed
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbGrief/Mourning' name='cbGriefMourning' className='add-only' value='GriefMourning' /> Grief/mourning
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAlexithymic' name='cbAlexithymic' className='add-only' value='Alexithymic' /> Alexithymic
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbElated' name='cbElated' className='add-only' value='Elated' /> Elated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHypomanic' name='cbHypomanic' className='add-only' value='Hypomanic' /> Hypomanic
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbManic' name='cbManic' className='add-only' value='Manic' /> Manic
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAnxious' name='cbAnxious' className='add-only' value='Anxious' /> Anxious
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTense' name='cbTense' className='add-only' value='Tense' /> Tense
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherDescribe_5' name='cbOtherDescribe_5' className='add-only' value='OtherDescribe_5' /> Other/Describe :
                            &nbsp;
                            <input type='text' id='txtOtherDescribe_5' name='txtOtherDescribe_5' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Speech </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNormal' name='cbNormal' className='add-only' value='Normal' /> Normal
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSpontaneous' name='cbSpontaneous' className='add-only' value='Spontaneous' /> Spontaneous
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSlow' name='cbSlow' className='add-only' value='Slow' /> Slow
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpoverished' name='cbImpoverished' className='add-only' value='Impoverished' /> Impoverished
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHesitant' name='cbHesitant' className='add-only' value='Hesitant' /> Hesitant
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMonotonous' name='cbMonotonous' className='add-only' value='Monotonous' /> Monotonous
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSoftWhispered' name='cbSoftWhispered' className='add-only' value='SoftWhispered' /> Soft/Whispered
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMumbled' name='cbMumbled' className='add-only' value='Mumbled' /> Mumbled
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRapid' name='cbRapid' className='add-only' value='Rapid' /> Rapid
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPressured' name='cbPressured' className='add-only' value='Pressured' /> Pressured
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbVerbose' name='cbVerbose' className='add-only' value='Verbose' /> Verbose
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLoud' name='cbLoud' className='add-only' value='Loud' /> Loud
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSlurred' name='cbSlurred' className='add-only' value='Slurred' /> Slurred
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpediment' name='cbImpediment' className='add-only' value='Impediment' /> Impediment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherDescribe_6' name='cbOtherDescribe_6' className='add-only' value='OtherDescribe_6' /> Other/Describe :
                            &nbsp;
                            <input type='text' id='txtOtherDescribe_6' name='txtOtherDescribe_6' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Affect </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAppropriate' name='cbAppropriate' className='add-only' value='Appropriate' /> Appropriate
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbInappropriate' name='cbInappropriate' className='add-only' value='Inappropriate' /> Inappropriate
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbBlunted' name='cbBlunted' className='add-only' value='Blunted' /> Blunted
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRestricted' name='cbRestricted' className='add-only' value='Restricted' /> Restricted
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbFlat' name='cbFlat' className='add-only' value='Flat' /> Flat
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLabile' name='cbLabile' className='add-only' value='Labile' /> Labile
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTearful' name='cbTearful' className='add-only' value='Tearful' /> Tearful
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIntense' name='cbIntense' className='add-only' value='Intense' /> Intense
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherDescribe_8' name='cbOtherDescribe_8' className='add-only' value='OtherDescribe_8' /> Other/Describe :
                            &nbsp;
                            <input type='text' id='txtOtherDescribe_8' name='txtOtherDescribe_8' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Perceptual Disturbances </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNone_4' name='cbNone_4' className='add-only' value='None' /> None
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHallucinations' name='cbHallucinations' className='add-only' value='Hallucinations' /> Hallucinations
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAuditory' name='cbAuditory' className='add-only' value='Auditory' /> Auditory
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbVisual' name='cbVisual' className='add-only' value='Visual' /> Visual
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOlfactory' name='cbOlfactory' className='add-only' value='Olfactory' /> Olfactory
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTactile' name='cbTactile' className='add-only' value='Tactile' /> Tactile
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherDescribe_9' name='cbOtherDescribe_9' className='add-only' value='OtherDescribe_9' /> Other/Describe :
                            &nbsp;
                            <input type='text' id='txtOtherDescribe_9' name='txtOtherDescribe_9' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Thought Process </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLogicalCoherent' name='cbLogicalCoherent' className='add-only' value='LogicalCoherent' /> Logical/Coherent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIncomprehensible' name='cbIncomprehensible' className='add-only' value='Incomprehensible' /> Incomprehensible
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIncoherent' name='cbIncoherent' className='add-only' value='Incoherent' /> Incoherent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbFlightOfIdeas' name='cbFlightOfIdeas' className='add-only' value='FlightOfIdeas' /> Flight of Ideas
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLooseAssociations' name='cbLooseAssociations' className='add-only' value='LooseAssociations' /> Loose Associations
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCircumstantial' name='cbCircumstantial' className='add-only' value='Circumstantial' /> Circumstantial
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRambling' name='cbRambling' className='add-only' value='Rambling' /> Rambling
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTangential' name='cbTangential' className='add-only' value='Tangential' /> Tangential
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEvasive' name='cbEvasive' className='add-only' value='Evasive' /> Evasive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRacingThoughts' name='cbRacingThoughts' className='add-only' value='RacingThoughts' /> Racing Thoughts
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPerseveration' name='cbPerseveration' className='add-only' value='Perseveration' /> Perseveration
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtBlocking' name='cbThoughtBlocking' className='add-only' value='ThoughtBlocking' /> Thought Blocking
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbConcrete' name='cbConcrete' className='add-only' value='Concrete' /> Concrete
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherDescribe_10' name='cbOtherDescribe_10' className='add-only' value='OtherDescribe_10' /> Other/Describe :
                            &nbsp;
                            <input type='text' id='txtOtherDescribe_10' name='txtOtherDescribe_10' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Thought Content</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPreoccupations' name='cbPreoccupations' className='add-only' value='Preoccupations' /> Preoccupations
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbObsessions' name='cbObsessions' className='add-only' value='Obsessions' /> Obsessions
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCompulsions' name='cbCompulsions' className='add-only' value='Compulsions' /> Compulsions
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPhobias' name='cbPhobias' className='add-only' value='Phobias' /> Phobias
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDelusions' name='cbDelusions' className='add-only' value='Delusions' /> Delusions
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtBroadcasting' name='cbThoughtBroadcasting' className='add-only' value='ThoughtBroadcasting' /> Thought Broadcasting
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtInsertion' name='cbThoughtInsertion' className='add-only' value='ThoughtInsertion' /> Thought Insertion
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThoughtWithdrawal' name='cbThoughtWithdrawal' className='add-only' value='ThoughtWithdrawal' /> Thought Withdrawal
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIdeasOfReference' name='cbIdeasOfReference' className='add-only' value='IdeasOfReference' /> Ideas of Reference
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIdeasOfInfluence' name='cbIdeasOfInfluence' className='add-only' value='IdeasOfInfluence' /> Ideas of Influence
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherDescribe_7' name='cbOtherDescribe_7' className='add-only' value='OtherDescribe_7' /> Other/Describe :
                            &nbsp;
                            <input type='text' id='txtOtherDescribe_7' name='txtOtherDescribe_7' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Suicidal/Homicidal Ideation</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSuicidalThoughts' name='cbSuicidalThoughts' className='add-only' value='SuicidalThoughts' /> Suicidal Thoughts
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSuicidalAttempts' name='cbSuicidalAttempts' className='add-only' value='SuicidalAttempts' /> Suicidal Attempts
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSuicidalIntent' name='cbSuicidalIntent' className='add-only' value='SuicidalIntent' /> Suicidal Intent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSuicidalPlans' name='cbSuicidalPlans' className='add-only' value='SuicidalPlans' /> Suicidal Plans
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHomicidalPlans' name='cbHomicidalPlans' className='add-only' value='HomicidalPlans' /> Homicidal Plans
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHomicidalThoughts' name='cbHomicidalThoughts' className='add-only' value='HomicidalThoughts' /> Homicidal Thoughts
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHomicidalAttempts' name='cbHomicidalAttempts' className='add-only' value='HomicidalAttempts' /> Homicidal Attempts
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHomicidalIntent' name='cbHomicidalIntent' className='add-only' value='HomicidalIntent' /> Homicidal Intent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHistoryOfSelfInjuriousBehavior' name='cbHistoryOfSelfInjuriousBehavior' className='add-only' value='HistoryOfSelfInjuriousBehavior' />  History of Self-Injurious Behavior
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherDescribe_11' name='cbOtherDescribe_11' className='add-only' value='OtherDescribe_11' /> Other/Describe :
                            &nbsp;
                            <input type='text' id='txtOtherDescribe_11' name='txtOtherDescribe_11' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Sensorium/Cognition</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAlert' name='cbAlert' className='add-only' value='Alert' /> Alert
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbLethargic' name='cbLethargic' className='add-only' value='Lethargic' /> Lethargic
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSomnolent' name='cbSomnolent' className='add-only' value='Somnolent' /> Somnolent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbStuporous' name='cbStuporous' className='add-only' value='Stuporous' /> Stuporous
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNormalConcentration' name='cbNormalConcentration' className='add-only' value='NormalConcentration' /> Normal Concentration
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbImpairedConcentration' name='cbImpairedConcentration' className='add-only' value='ImpairedConcentration' /> Impaired Concentration
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherDescribe_12' name='cbOtherDescribe_12' className='add-only' value='OtherDescribe_12' /> Other/Describe :
                            &nbsp;
                            <input type='text' id='txtOtherDescribe_12' name='txtOtherDescribe_12' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b> Oriented To:</b>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='Person' name='rbOrientedTo' className='add-only' value='Person' /> Person&nbsp;&nbsp;
                            <input type='radio' id='Place' name='rbOrientedTo' className='add-only' value='Place' /> Place&nbsp;&nbsp;
                            <input type='radio' id='Time' name='rbOrientedTo' className='add-only' value='Time' /> Time
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h5>Memory</h5>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Memory</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Remote Memory : </b>
                            <input type='radio' id='rbRemoteMemoryNormal' name='rbRemoteMemory' className='add-only' value='Normal' /> Normal&nbsp;&nbsp;
                            <input type='radio' id='rbRemoteMemoryImpaired' name='rbRemoteMemory' className='add-only' value='Impaired' /> Impaired
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Recent Memory : </b>
                            <input type='radio' id='rbRecentMemoryNormal' name='rbRecentMemory' className='add-only' value='Normal' /> Normal&nbsp;&nbsp;
                            <input type='radio' id='rbRecentMemoryImpaired' name='rbRecentMemory' className='add-only' value='Impaired' /> Impaired
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><b> Remote Memory : </b>
                            <input type='radio' id='rbImmediateRecallNormal' name='rbImmediateRecall' className='add-only' value='Normal' /> Normal&nbsp;&nbsp;
                            <input type='radio' id='rbImmediateRecallImpaired' name='rbImmediateRecall' className='add-only' value='Impaired' /> Impaired
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherDescribe_13' name='cbOtherDescribe_13' className='add-only' value='OtherDescribe_13' /> Other/Describe :
                            &nbsp;
                            <input type='text' id='txtOtherDescribe_13' name='txtOtherDescribe_13' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Intellectual Functioning (Estimate)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='AboveAvg' name='rbIntellectualFunctioning' className='add-only' value='AboveAvg' /> Above Avg.</td>
                        <td className='w-187'><input type='radio' id='NormalAvg' name='rbIntellectualFunctioning' className='add-only' value='NormalAvg' /> Normal/Avg</td>
                        <td className='w-187'><input type='radio' id='Borderline' name='rbIntellectualFunctioning' className='add-only' value='Borderline' /> Borderline</td>
                        <td className='w-187'><input type='radio' id='MentalRetardation ' name='rbIntellectualFunctioning' className='add-only' value='MentalRetardation ' /> Mental Retardation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='Mild' name='rbIntellectualFunctioning' className='add-only' value='Mild' /> Mild</td>
                        <td className='w-187'><input type='radio' id='Moderate' name='rbIntellectualFunctioning' className='add-only' value='Moderate' /> Moderate</td>
                        <td className='w-187'><input type='radio' id='Severe' name='rbIntellectualFunctioning' className='add-only' value='Severe' /> Severe
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherDescribe_14' name='cbOtherDescribe_14' className='add-only' value='OtherDescribe_14' /> Other/Describe :
                            &nbsp;
                            <input type='text' id='txtOtherDescribe_14' name='txtOtherDescribe_14' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Judgement</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='CriticalJudgementIntact' name='rbJudgementg' className='add-only' value='CriticalJudgementIntact' /> Critical Judgement Intact</td>
                        <td className='w-250'><input type='radio' id='ImpairedJudgment' name='rbJudgementg' className='add-only' value='ImpairedJudgment' /> Impaired Judgment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherDescribe_15' name='cbOtherDescribe_15' className='add-only' value='OtherDescribe_15' /> Other/Describe :
                            &nbsp;
                            <input type='text' id='txtOtherDescribe_15' name='txtOtherDescribe_15' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Insight</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTrueEmotionalInsight' name='cbTrueEmotionalInsight' className='add-only' value='TrueEmotionalInsight' />  True Emotional Insight
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIntellectualInsight' name='cbIntellectualInsight' className='add-only' value='IntellectualInsight' /> Intellectual Insight
                        </td>

                        <td className='w-187'>
                            <input type='checkbox' id='cbImpairedInsight' name='cbImpairedInsight' className='add-only' value='ImpairedInsight' /> Impaired Insight
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDenial' name='cbDenial' className='add-only' value='Denial' /> Denial
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSomeAwarenessOfIllnessSymptoms' name='cbSomeAwarenessOfIllnessSymptoms' className='add-only' value='SomeAwarenessOfIllnessSymptoms' /> Some Awareness of Illness/Symptoms
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherDescribe_16' name='cbOtherDescribe_16' className='add-only' value='OtherDescribe_16' /> Other/Describe :
                            &nbsp;
                            <input type='text' id='txtOtherDescribe_16' name='txtOtherDescribe_16' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Impulse Control</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAbleToResistImpulses' name='cbAbleToResistImpulses' className='add-only' value='AbleToResistImpulses' /> Able to Resist Impulses
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecentImpulsiveBehavior' name='cbRecentImpulsiveBehavior' className='add-only' value='RecentImpulsiveBehavior' /> Recent Impulsive Behavior
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbImpairedImpulseControl' name='cbImpairedImpulseControl' className='add-only' value='ImpairedImpulseControl' /> Impaired Impulse Control
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbCompulsions' name='cbCompulsions' className='add-only' value='Compulsions' /> Compulsions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherDescribe_17' name='cbOtherDescribe_17' className='add-only' value='OtherDescribe_17' /> Other/Describe :
                            &nbsp;
                            <input type='text' id='txtOtherDescribe_17' name='txtOtherDescribe_17' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Printed Name of LMHP </td>
                        <td className='small w-375'> Signature </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> LMHP Status </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'><center>Treatment Plan Goals Update</center></td>
                    </tr>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Goal <br />&nbsp;<br />&nbsp;</span></td>
                        <td className='w-250'><span className='eleHeader'>Progress Made <span className='small'>(no progress, minor progress, moderate progress, goal achieved)</span></span></td>
                        <td className='w-250'><span className='eleHeader'>Remarks <br />&nbsp;<br />&nbsp;</span></td>
                    </tr>


                    <tr>
                        <td className='w-250'><input type='text' id='txtGoal_1' name='txtGoal_1' /></td>
                        <td className='w-250'><input type='text' id='txtProgress_1' name='txtProgress_1' /></td>
                        <td className='w-250'><input type='text' id='txtRemarks_1' name='txtRemarks_1' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='text' id='txtGoal_2' name='txtGoal_2' /></td>
                        <td className='w-250'><input type='text' id='txtProgress_2' name='txtProgress_2' /></td>
                        <td className='w-250'><input type='text' id='txtRemarks_2' name='txtRemarks_2' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='text' id='txtGoal_3' name='txtGoal_3' /></td>
                        <td className='w-250'><input type='text' id='txtProgress_3' name='txtProgress_3' /></td>
                        <td className='w-250'><input type='text' id='txtRemarks_3' name='txtRemarks_3' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='text' id='txtGoal_4' name='txtGoal_4' /></td>
                        <td className='w-250'><input type='text' id='txtProgress_4' name='txtProgress_4' /></td>
                        <td className='w-250'><input type='text' id='txtRemarks_4' name='txtRemarks_4' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='text' id='txtGoal_5' name='txtGoal_5' /></td>
                        <td className='w-250'><input type='text' id='txtProgress_5' name='txtProgress_5' /></td>
                        <td className='w-250'><input type='text' id='txtRemarks_5' name='txtRemarks_5' /></td>
                    </tr>

                    <tr>
                        <td className='w-250'><input type='text' id='txtGoal_6' name='txtGoal_6' /></td>
                        <td className='w-250'><input type='text' id='txtProgress_6' name='txtProgress_6' /></td>
                        <td className='w-250'><input type='text' id='txtRemarks_6' name='txtRemarks_6' /></td>
                    </tr>

                </table>

                <table>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>Which interventions/resources do you feel have been helpful?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtWhichInterventions' name='txtWhichInterventions' /></td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Which interventions/resources do you feel have not been helpful?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtWhichInterventionsNot' name='txtWhichInterventionsNot' /></td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>How have your symptoms changed since you started services?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtSymptomsChanged' name='txtSymptomsChanged' /></td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>What are some of your current life stressors that are affecting your mental health and daily living?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtLifeStressor' name='txtLifeStressor' /></td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>How have you been functioning on your job/home/school?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtFunctioningOnJob' name='txtFunctioningOnJob' /></td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Has there been any recent changes in your life? Good or Bad (raise, promotion, demotion, fighting with co workers, neighbors, moved homes, evictions, etc. )</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtChangesInLife' name='txtChangesInLife' /></td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Have you been compliant with medication management? (if applicable) </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtMedicationManagement' name='txtMedicationManagement' /></td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Any major health changes since your last assessment?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtHealthChanges' name='txtHealthChanges' /></td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Any SI/HI since your last assessment?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtLastAssessment' name='txtLastAssessment' /></td>
                    </tr>


                    <tr>
                        <td className='w-750'><span className='eleHeader'>Have you been hospitalized (inpatient) since your last assessment? If so, when and where?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='text' id='txtHospitalized' name='txtHospitalized' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>MEMBER NAME:</span></td>
                        <td className='w-375'><span className='eleHeader'>MEDICAID NUMBER:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='text' id='txtMemberName' name='txtMemberName' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtMedicaidNumber' name='txtMedicaidNumber' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><h1>LOCUS SCORE SHEET:</h1></p>

                <table>
                    <tr>
                        <td className='w-50'><span className='eleHeader'>&nbsp;</span></td>
                        <td className='w-500'><span className='eleHeader'>DIMENSIONS</span></td>
                        <td className='w-100'><span className='eleHeader'>CURRENT</span></td>
                        <td className='w-100'><span className='eleHeader'>CRITERIA</span></td>
                    </tr>

                    <tr>
                        <td className='w-50'><center>I</center></td>
                        <td className='w-500'>RISK OF HARM <br />AEB: <input type='text' id='txtAebI' name='txtAebI' className='add-only w-300 custom-add-only' /></td>
                        <td className='w-100'><input type='text' id='txtRiskOfHarmCurrent' name='txtRiskOfHarmCurrent' /></td>
                        <td className='w-100'><input type='text' id='txtRiskOfHarmCriteria' name='txtRiskOfHarmCriteria' /></td>
                    </tr>

                    <tr>
                        <td className='w-50'><center>II</center></td>
                        <td className='w-500'>FUNCTIONAL STATUS <br />AEB: <input type='text' id='txtAebII' name='txtAebII' className='add-only w-300 custom-add-only' /></td>
                        <td className='w-100'><input type='text' id='txtRiskOfHarmCurrent' name='txtRiskOfHarmCurrent' /></td>
                        <td className='w-100'><input type='text' id='txtRiskOfHarmCriteria' name='txtRiskOfHarmCriteria' /></td>
                    </tr>

                    <tr>
                        <td className='w-50'><center>III</center></td>
                        <td className='w-500'>MEDICAL, ADDICTIVE, PSYCHIATRIC CO-MORBIDITY <br />AEB: <input type='text' id='txtAebIII' name='txtAebIII' className='add-only w-300 custom-add-only' /></td>
                        <td className='w-100'><input type='text' id='txtRiskOfHarmCurrent' name='txtRiskOfHarmCurrent' /></td>
                        <td className='w-100'><input type='text' id='txtRiskOfHarmCriteria' name='txtRiskOfHarmCriteria' /></td>
                    </tr>

                    <tr>
                        <td className='w-50'><center>IV-A</center></td>
                        <td className='w-500'>RECOVERY ENVIRONMENT (STRESS) <br />AEB: <input type='text' id='txtAebIVA' name='txtAebIVA' className='add-only w-300 custom-add-only' /></td>
                        <td className='w-100'><input type='text' id='txtRiskOfHarmCurrent' name='txtRiskOfHarmCurrent' /></td>
                        <td className='w-100'><input type='text' id='txtRiskOfHarmCriteria' name='txtRiskOfHarmCriteria' /></td>
                    </tr>

                    <tr>
                        <td className='w-50'><center>IV-B</center></td>
                        <td className='w-500'>RECOVERY ENVIRONMENT (SUPPORT) <br />AEB: <input type='text' id='txtAebIVB' name='txtAebIVB' className='add-only w-300 custom-add-only' /></td>
                        <td className='w-100'><input type='text' id='txtRiskOfHarmCurrent' name='txtRiskOfHarmCurrent' /></td>
                        <td className='w-100'><input type='text' id='txtRiskOfHarmCriteria' name='txtRiskOfHarmCriteria' /></td>
                    </tr>

                    <tr>
                        <td className='w-50'><center>V</center></td>
                        <td className='w-500'>RECOVERY ENVIRONMENT (SUPPORT) <br />AEB: <input type='text' id='txtAebV' name='txtAebV' className='add-only w-300 custom-add-only' /></td>
                        <td className='w-100'><input type='text' id='txtRiskOfHarmCurrent' name='txtRiskOfHarmCurrent' /></td>
                        <td className='w-100'><input type='text' id='txtRiskOfHarmCriteria' name='txtRiskOfHarmCriteria' /></td>
                    </tr>

                    <tr>
                        <td className='w-50'><center>VI</center></td>
                        <td className='w-500'>ENGAGEMENT <br />AEB: <input type='text' id='txtAebVI' name='txtAebVI' className='add-only w-300 custom-add-only' /></td>
                        <td className='w-100'><input type='text' id='txtRiskOfHarmCurrent' name='txtRiskOfHarmCurrent' /></td>
                        <td className='w-100'><input type='text' id='txtRiskOfHarmCriteria' name='txtRiskOfHarmCriteria' /></td>
                    </tr>

                    <tr>
                        <td className='w-550'>COMPOSITE SCORE:</td>
                        <td className='w-200'><input type='text' id='txtRiskOfHarmCriteria' name='txtRiskOfHarmCriteria' /></td>
                    </tr>

                    <tr>
                        <td className='w-550'>LEVEL OF CARE RECOMMENDED:</td>
                        <td className='w-200'><input type='text' id='txtRiskOfHarmCriteria' name='txtRiskOfHarmCriteria' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> Notes:</span>
                    <textarea id='txtChiefComplaint' name='txtChiefComplaint' className='add-only'> </textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-500'> LMHP PRINTED NAME</td>
                        <td className='small w-250'>&nbsp; LMHP SIGNATURE/DATE</td>
                    </tr>
                </table>


                <p className='w-750'><b>ASQ :</b> Ask Suicide-Screening Questions</p>

                <table>
                    <tr>
                        <td className='w-500'><span className='eleHeader'>Name:</span></td>
                        <td className='w-250'><span className='eleHeader'>Date of Birth:</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'><input type='text' id='textAsqName' name='textAsqName' className='add-only' /></td>
                        <td className='w-250'><input type='date' id='textAsqDob' name='textAsqDob' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>Ask the patient</b></p>

                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>1. In the past few weeks, have you wished you were dead?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbWishedDeadYes' name='rbWishedDead' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbWishedDeadNo' name='rbWishedDead' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>2. In the past few weeks, have you felt that you or your family
                            would be better off if you were dead? </span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbFamilyDeadYes' name='rbFamilyDead' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbFamilyDeadNo' name='rbFamilyDead' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>3. In the past week, have you been having thoughts
                            about killing yourself?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbKillingYourselfYes' name='rbKillingYourself' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbKillingYourselfNo' name='rbKillingYourself' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>4. Have you ever tried to kill yourself?</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>

                            <input type='radio' id='rbTriedKillYourselfYes' name='rbTriedKillYourself' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbTriedKillYourselfNo' name='rbTriedKillYourself' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>If yes, how?</span>
                            <input type='text' id='txtKillYourselfHow' name='txtKillYourselfHow' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>When?</span>
                            <input type='text' id='txtKillYourselfHow' name='txtKillYourselfHow' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><b>If the patient answers Yes to any of the above, ask the following acuity question:</b></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>5. Are you having thoughts of killing yourself right now?</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>

                            <input type='radio' id='rbKillingRightNowYes' name='rbKillingRightNow' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbKillingRightNowNo' name='rbKillingRightNow' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>If yes, please describe:</span>
                            <input type='text' id='txtKillingRightNowDescribe' name='txtKillingRightNowDescribe' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <ul>
                        <li className='w-750'>
                            If patient answers “No” to all questions 1 through 4, screening is complete (not necessary to ask question #5).
                            No intervention is necessary (*Note: Clinical judgment can always override a negative screen).
                        </li>
                        <li className='w-750'>
                            If patient answers “Yes” to any of questions 1 through 4, or refuses to answer, they are considered a
                            positive screen. Ask question #5 to assess acuity:
                        </li>
                        <input type='radio' id='rbPatientAnswerYes' name='rbPatientAnswer' className='add-only' value='Yes' />
                        <b>“Yes”</b> to question #5 = acute positive screen (imminent risk identified)
                        <ul>
                            <li className='w-750'>Patient requires a STAT safety/full mental health evaluation.
                                Patient cannot leave until evaluated for safety.
                            </li>
                            <li className='w-750'>
                                Keep patient in sight. Remove all dangerous objects from room. Alert physician or clinician
                                responsible for patient's care.
                            </li>
                        </ul>

                        <input type='radio' id='rbPatientAnswerNo' name='rbPatientAnswer' className='add-only' value='No' />
                        <b>“No”</b> to question #5 = <b>non-acute positive screen</b> (potential risk identified)
                        <ul>
                            <li className='w-750'>
                                Patient requires a <b>brief</b> suicide safety assessment to determine if a <b>full</b> mental health evaluation
                                is needed. <b>Patient cannot leave until evaluated for safety</b>
                            </li>
                            <li className='w-750'>
                                Alert physician or clinician responsible for patient's care.
                            </li>
                        </ul>
                    </ul>
                </table>

                <p className='w-750'><span className='eleHeader'>Provide resources to all patients</span></p>
                <ul>
                    <li className='w-750'>
                        24/7 National Suicide Prevention Lifeline 1-800-273-TALK (8255) En Español: 1-888-628-9454
                    </li>
                    <li className='w-750'>
                        24/7 Crisis Text Line: Text “HOME” to 741-741
                    </li>
                </ul>

                <table>
                    <tr>
                        <td className='signature w-250'></td>
                        <td className='signature w-250'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-250'> LMHP Name:</td>
                        <td className='small w-250'>&nbsp; LMHP Signature:</td>
                        <td className='small w-250'>&nbsp;&nbsp; Date:</td>
                    </tr>
                </table>
                <p className='w-750'><center><h2>DSM-5 Self-Rated Level 1 Cross-Cutting Symptom Measure—Adult</h2></center></p>

                <table>
                    <tr>
                        <td className='w-350'><span className='eleHeader'>Name:</span></td>
                        <td className='w-100'><span className='eleHeader'>Age:</span></td>
                        <td className='w-150'><span className='eleHeader'>Sex:</span></td>
                        <td className='w-150'><span className='eleHeader'>Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-350'>
                            <input type='text' id='txtName' name='txtName' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtAge' name='txtAge' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <center>
                                <input type='radio' id='rbNameSexMale' name='rbSex' className='add-only' value='Male' /> Male &nbsp;
                                <input type='radio' id='rbNameSexFemale' name='rbSex' className='add-only' value='Female' /> Female
                            </center>
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' />
                        </td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-350'>If this questionnaire is completed by an informant,<b><br /> what is your relationship with the individual?</b></td>
                        <td className='w-400'>
                            <input type='text' id='txtRelationshipWithIndividual' name='txtRelationshipWithIndividual' placeholder='LCSW' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-350'><b>In a typical week, approximately how much time do you spend with the individual? </b></td>
                        <td className='w-250'>
                            <input type='text' id='txtTimeSpentWithIndividual' name='txtTimeSpentWithIndividual' placeholder='During Assessments' className='add-only' />
                        </td>
                        <td className='w-150'><b>hours/week </b></td>
                    </tr>
                </table>

                <p className='w-750'><b>Instructions:</b>The questions below ask about things that might have bothered you. For each question, circle the number that best
                    describes how much (or how often) you have been bothered by each problem during the <b>past TWO (2) WEEKS.</b>
                </p>

                <p className='w-750'><b>During the past TWO (2) WEEKS, how much (or how often) have you been bothered by the following problems? </b></p>

                <table>
                    <tr>
                        <td className='w-150'><b>(0) <br />None <br /></b>Not at all</td>
                        <td className='w-150'><b>(1) <br />Slight <br /></b>Rare, less than a day or two</td>
                        <td className='w-150'><b>(2) <br />Mild <br /></b>Several days</td>
                        <td className='w-150'><b>(3) <br />Moderate <br /></b>More than half the days</td>
                        <td className='w-150'><b>(4) <br />Severe <br /></b>Nearly every day</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>I.  1. Little interest or pleasure in doing things?</span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemI1_0' name='rbProblemI1' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemI1_1' name='rbProblemI1' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemI1_2' name='rbProblemI1' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemI1_3' name='rbProblemI1' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemI1_4' name='rbProblemI1' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem1' name='txtProblem1' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>2. Feeling down, depressed, or hopeless?</span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemI2_0' name='rbProblemI2' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemI2_1' name='rbProblemI2' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemI2_2' name='rbProblemI2' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemI2_3' name='rbProblemI2' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemI2_4' name='rbProblemI2' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem2' name='txtProblem2' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>II.  3. Feeling more irritated, grouchy, or angry than usual? </span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemII3_0' name='rbProblemII3' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemII3_1' name='rbProblemII3' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemII3_2' name='rbProblemII3' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemII3_3' name='rbProblemII3' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemII3_4' name='rbProblemII3' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem3' name='txtProblem3' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>III.  4. Sleeping less than usual, but still have a lot of energy?</span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemIII4_0' name='rbProblemIII4' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemIII4_1' name='rbProblemIII4' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemIII4_2' name='rbProblemIII4' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemIII4_3' name='rbProblemIII4' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemIII4_4' name='rbProblemIII4' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem4' name='txtProblem4' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>5. Starting lots more projects than usual or doing more risky things than usual? </span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemIII5_0' name='rbProblemIII5' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemIII5_1' name='rbProblemIII5' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemIII5_2' name='rbProblemIII5' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemIII5_3' name='rbProblemIII5' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemIII5_4' name='rbProblemIII5' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem5' name='txtProblem5' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>IV.  6. Feeling nervous, anxious, frightened, worried, or on edge?</span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemIV6_0' name='rbProblemIV6' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemIV6_1' name='rbProblemIV6' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemIV6_2' name='rbProblemIV6' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemIV6_3' name='rbProblemIV6' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemIV6_4' name='rbProblemIV6' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem6' name='txtProblem6' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>7. Feeling panic or being frightened?</span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemIV7_0' name='rbProblemIV7' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemIV7_1' name='rbProblemIV7' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemIV7_2' name='rbProblemIV7' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemIV7_3' name='rbProblemIV7' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemIV7_4' name='rbProblemIV7' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem7' name='txtProblem7' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>8. Avoiding situations that make you anxious?</span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemIV8_0' name='rbProblemIV8' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemIV8_1' name='rbProblemIV8' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemIV8_2' name='rbProblemIV8' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemIV8_3' name='rbProblemIV8' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemIV8_4' name='rbProblemIV8' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem8' name='txtProblem8' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>V.  9. Unexplained aches and pains (e.g., head, back, joints, abdomen, legs)?</span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemV9_0' name='rbProblemV9' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemV9_1' name='rbProblemV9' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemV9_2' name='rbProblemV9' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemV9_3' name='rbProblemV9' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemV9_4' name='rbProblemV9' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem9' name='txtProblem9' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>10. Feeling that your illnesses are not being taken seriously enough? </span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemV10_0' name='rbProblemV10' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemV10_1' name='rbProblemV10' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemV10_2' name='rbProblemV10' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemV10_3' name='rbProblemV10' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemV10_4' name='rbProblemV10' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem10' name='txtProblem10' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>VI.  11. Thoughts of actually hurting yourself? </span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemVI11_0' name='rbProblemVI11' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemVI11_1' name='rbProblemVI11' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemVI11_2' name='rbProblemVI11' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemVI11_3' name='rbProblemVI11' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemVI11_4' name='rbProblemVI11' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem11' name='txtProblem11' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>VII.  12. Hearing things other people couldn't hear, such as voices even when no one was around? </span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemVII12_0' name='rbProblemVII12' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemVII12_1' name='rbProblemVII12' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemVII12_2' name='rbProblemVII12' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemVII12_3' name='rbProblemVII12' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemVII12_4' name='rbProblemVII12' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem12' name='txtProblem12' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>13. Feeling that someone could hear your thoughts, or that you could hear what another person was thinking? </span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemVII13_0' name='rbProblemVII13' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemVII13_1' name='rbProblemVII13' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemVII13_2' name='rbProblemVII13' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemVII13_3' name='rbProblemVII13' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemVII13_4' name='rbProblemVII13' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem13' name='txtProblem13' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>VIII.  14. Problems with sleep that affected your sleep quality over all?</span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemVIII14_0' name='rbProblemVIII14' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemVIII14_1' name='rbProblemVIII14' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemVIII14_2' name='rbProblemVIII14' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemVIII14_3' name='rbProblemVIII14' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemVIII14_4' name='rbProblemVIII14' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem14' name='txtProblem14' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>IX.  15. Problems with memory (e.g., learning new information) or with location (e.g., finding your way home)? </span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemIX15_0' name='rbProblemIX15' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemIX15_1' name='rbProblemIX15' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemIX15_2' name='rbProblemIX15' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemIX15_3' name='rbProblemIX15' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemIX15_4' name='rbProblemIX15' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem15' name='txtProblem15' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>X.  16. Unpleasant thoughts, urges, or images that repeatedly enter your mind? </span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemX16_0' name='rbProblemX16' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemX16_1' name='rbProblemX16' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemX16_2' name='rbProblemX16' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemX16_3' name='rbProblemX16' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemX16_4' name='rbProblemX16' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem16' name='txtProblem16' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>17. Feeling driven to perform certain behaviors or mental acts over and over again?</span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemX17_0' name='rbProblemX17' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemX17_1' name='rbProblemX17' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemX17_2' name='rbProblemX17' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemX17_3' name='rbProblemX17' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemX17_4' name='rbProblemX17' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem17' name='txtProblem17' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>XI.  18. Feeling detached or distant from yourself, your body, your physical surroundings, or your memories? </span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemXI18_0' name='rbProblemXI18' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemXI18_1' name='rbProblemXI18' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemXI18_2' name='rbProblemXI18' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemXI18_3' name='rbProblemXI18' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemXI18_4' name='rbProblemXI18' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem18' name='txtProblem18' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>XII.  19. Not knowing who you really are or what you want out of life? </span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemXII19_0' name='rbProblemXII19' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemXII19_1' name='rbProblemXII19' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemXII19_2' name='rbProblemXII19' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemXII19_3' name='rbProblemXII19' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemXII19_4' name='rbProblemXII19' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem19' name='txtProblem19' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>20. Not feeling close to other people or enjoying your relationships with them? </span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemXII20_0' name='rbProblemXII20' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemXII20_1' name='rbProblemXII20' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemXII20_2' name='rbProblemXII20' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemXII20_3' name='rbProblemXII20' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemXII20_4' name='rbProblemXII20' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem20' name='txtProblem20' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>XIII.  21. Drinking at least 4 drinks of any kind of alcohol in a single day? </span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemXIII21_0' name='rbProblemXIII21' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemXIII21_1' name='rbProblemXIII21' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemXIII21_2' name='rbProblemXIII21' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemXIII21_3' name='rbProblemXIII21' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemXIII21_4' name='rbProblemXIII21' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem21' name='txtProblem21' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>22. Smoking any cigarettes, a cigar, or pipe, or using snuff or chewing tobacco? </span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemXIII22_0' name='rbProblemXIII22' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemXIII22_1' name='rbProblemXIII22' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemXIII22_2' name='rbProblemXIII22' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemXIII22_3' name='rbProblemXIII22' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemXIII22_4' name='rbProblemXIII22' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem22' name='txtProblem22' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>


                <p className='w-750'><span className='eleHeader'>23. Using any of the following medicines ON YOUR OWN, that is, without a
                    doctor's prescription, in greater amounts or longer than prescribed [e.g.,
                    painkillers (like Vicodin), stimulants (like Ritalin or Adderall), sedatives or
                    tranquilizers (like sleeping pills or Valium), or drugs like marijuana, cocaine
                    or crack, club drugs (like ecstasy), hallucinogens (like LSD), heroin,
                    inhalants or solvents (like glue), or methamphetamine (like speed)]?</span></p>
                <table>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemXIII23_0' name='rbProblemXIII23' className='add-only' value='0' /> 0 (None) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemXIII23_1' name='rbProblemXIII23' className='add-only' value='1' /> 1 (Slight) &nbsp;</td>
                        <td className='w-250'><input type='radio' id='rbProblemXIII23_2' name='rbProblemXIII23' className='add-only' value='2' /> 2 (Mild) &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='radio' id='rbProblemXIII23_3' name='rbProblemXIII23' className='add-only' value='3' /> 3 (Moderate) &nbsp; </td>
                        <td className='w-250'><input type='radio' id='rbProblemXIII23_4' name='rbProblemXIII23' className='add-only' value='4' /> 4 (Severe) &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-750'>Highest Domain Score (clinician): <input type='text' id='txtProblem23' name='txtProblem23' className='add-only w-50 custom-add-only' /></td>

                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-250'></td>
                        <td className='signature w-250'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-250'> LMHP Name:</td>
                        <td className='small w-250'>&nbsp; LMHP Signature:</td>
                        <td className='small w-250'>&nbsp;&nbsp; Date:</td>
                    </tr>
                </table>



                <p className='w-750'><b>Instructions to Clinicians</b><br />
                    The DSM-5 Level 1 Cross-Cutting Symptom Measure is a self- or informant-rated measure that assesses mental health
                    domains that are important across psychiatric diagnoses. It is intended to help clinicians identify additional areas of inquiry
                    that may have significant impact on the individual's treatment and prognosis. In addition, the measure may be used to track
                    changes in the individual's symptom presentation over time. <br />
                    This adult version of the measure consists of 23 questions that assess 13 psychiatric domains, including depression, anger,
                    mania, anxiety, somatic symptoms, suicidal ideation, psychosis, sleep problems, memory, repetitive thoughts and behaviors,
                    dissociation, personality functioning, and substance use. Each item inquires about how much (or how often) the individual has
                    been bothered by the specific symptom <u>during the past 2 weeks</u>. If the individual is of impaired capacity and unable to
                    complete the form (e.g., an individual with dementia), a knowledgeable adult informant may complete the measure. The
                    measure was found to be clinically useful and to have good test-retest reliability in the DSM-5 Field Trials that were conducted
                    in adult clinical samples across the United States and in Canada. </p>
                <p className='w-750'>
                    <b>Scoring and Interpretation</b><br />
                    Each item on the measure is rated on a 5-point scale (0=none or not at all; 1=slight or rare, less than a day or two; 2=mild or
                    several days; 3=moderate or more than half the days; and 4=severe or nearly every day). The score on each item within a
                    domain should be reviewed. Because additional inquiry is based on the highest score on any item within a domain, the
                    clinician is asked to indicate that score in the “Highest Domain Score” column. A rating of mild (i.e., 2) or greater on <u>any item
                        within a domain</u> (except for substance use, suicidal ideation, and psychosis) may serve as a guide for additional inquiry and
                    follow up to determine if a more detailed assessment for that domain is necessary. For substance use, suicidal ideation, and
                    psychosis, a rating of slight (i.e., 1) or greater on any item within the domain may serve as a guide for additional inquiry and
                    follow-up to determine if a more detailed assessment is needed. The DSM-5 Level 2 Cross-Cutting Symptom Measures may be
                    used to provide more detailed information on the symptoms associated with some of the Level 1 domains (see Table 1 below).
                </p>
                <p className='w-750'>
                    <b>Frequency of Use</b> <br />
                    To track change in the individual's symptom presentation over time, the measure may be completed at regular intervals as
                    clinically indicated, depending on the stability of the individual's symptoms and treatment status. For individuals with
                    impaired capacity, it is preferable that the same knowledgeable informant completes the measures at follow-up
                    appointments. Consistently high scores on a particular domain may indicate significant and problematic symptoms for the
                    individual that might warrant further assessment, treatment, and follow-up. Clinical judgment should guide decision making.
                    Table 1: Adult DSM-5 Self-Rated Level 1 Cross-Cutting Symptom Measure: domains, thresholds for further inquiry, and
                    associated Level 2 measures for adults ages 18 and over</p>

                <p className='w-750'><b>Table 1: Adult DSM-5 Self-Rated Level 1 Cross-Cutting Symptom Measure: domains, thresholds for further inquiry, and
                    associated Level 2 measures for adults ages 18 and over</b></p>


                <table>
                    <tr>
                        <td className='w-100'><span className='eleHeader'>Domain <br /> &nbsp;</span></td>
                        <td className='w-100'><span className='eleHeader'>Domain Name</span></td>
                        <td className='w-150'><span className='eleHeader'>Threshold to guide further inquiry</span></td>
                        <td className='w-400'><span className='eleHeader'>DSM-5 Level 2 Cross-Cutting Symptom Measure available online</span></td>
                    </tr>
                    <tr>
                        <td className='w-100'><center>I. </center></td>
                        <td className='w-100'>Depression </td>
                        <td className='w-150'>Mild or greater </td>
                        <td className='w-400'>LEVEL 2—Depression—Adult (PROMIS Emotional <br />Distress—Depression—Short Form) 1
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'><center>II. </center></td>
                        <td className='w-100'>Anger </td>
                        <td className='w-150'>Mild or greater </td>
                        <td className='w-400'>LEVEL 2—Anger—Adult <br />(PROMIS Emotional Distress—Anger—Short Form)1</td>
                    </tr>
                    <tr>
                        <td className='w-100'><center>III. </center></td>
                        <td className='w-100'>Mania </td>
                        <td className='w-150'>Mild or greater </td>
                        <td className='w-400'>LEVEL 2—Mania—Adult (Altman Self-Rating Mania Scale)</td>
                    </tr>
                    <tr>
                        <td className='w-100'><center>IV. </center></td>
                        <td className='w-100'>Anxiety </td>
                        <td className='w-150'>Mild or greater </td>
                        <td className='w-400'>LEVEL 2—Anxiety—Adult (PROMIS Emotional Distress—Anxiety—Short Form)1</td>
                    </tr>
                    <tr>
                        <td className='w-100'><center>V. </center></td>
                        <td className='w-100'>Somatic Symptoms </td>
                        <td className='w-150'>Mild or greater </td>
                        <td className='w-400'>LEVEL 2—Somatic Symptom—Adult (Patient Health Questionnaire 15 Somatic Symptom Severity [PHQ-15])</td>
                    </tr>
                    <tr>
                        <td className='w-100'><center>VI. </center></td>
                        <td className='w-100'>Suicidal Ideation </td>
                        <td className='w-150'>Slight or greater </td>
                        <td className='w-400'>None</td>
                    </tr>
                    <tr>
                        <td className='w-100'><center>VII. </center></td>
                        <td className='w-100'>Psychosis </td>
                        <td className='w-150'>Slight or greater </td>
                        <td className='w-400'>None</td>
                    </tr>
                    <tr>
                        <td className='w-100'><center>VIII. </center></td>
                        <td className='w-100'>Sleep Problems </td>
                        <td className='w-150'>Mild or greater </td>
                        <td className='w-400'>LEVEL 2—Sleep Disturbance - Adult (PROMIS—Sleep Disturbance—Short Form)1</td>
                    </tr>
                    <tr>
                        <td className='w-100'><center>IX. </center></td>
                        <td className='w-100'>Memory </td>
                        <td className='w-150'>Mild or greater </td>
                        <td className='w-400'>None</td>
                    </tr>
                    <tr>
                        <td className='w-100'><center>X. </center></td>
                        <td className='w-100'>Repetitive Thoughts and Behaviors </td>
                        <td className='w-150'>Mild or greater </td>
                        <td className='w-400'>LEVEL 2—Repetitive Thoughts and Behaviors—Adult (adapted from the Florida Obsessive-Compulsive <br />Inventory [FOCI] Severity Scale [Part B])</td>
                    </tr>
                    <tr>
                        <td className='w-100'><center>XI. </center></td>
                        <td className='w-100'>Dissociation </td>
                        <td className='w-150'>Mild or greater </td>
                        <td className='w-400'>None</td>
                    </tr>
                    <tr>
                        <td className='w-100'><center>XII. </center></td>
                        <td className='w-100'>Personality
                            Functioning </td>
                        <td className='w-150'>Mild or greater </td>
                        <td className='w-400'>None</td>
                    </tr>
                    <tr>
                        <td className='w-100'><center>XIII. </center></td>
                        <td className='w-100'>Substance Use </td>
                        <td className='w-150'>Slight or greater </td>
                        <td className='w-400'>LEVEL 2—Substance Abuse—Adult <br />(adapted from the NIDA-modified ASSIST)</td>
                    </tr>

                </table>


            </div>
        </form>

    )
}











